// 0-B 회색박스 — **밤 = 순수 회피 생존.** 양은 화면에 없다(N22 예외).
// 적은 전부 플레이어에게 온다. 입력은 이동 하나. 안정성이 유일한 판돈.
//
// 이번 차수(개정지시서 v2, 2026-07-27) 반영 4건:
//   3-1  **안정성에서 피격 항 제거.** HP = 사고 / 안정성 = 자세.
//   4-3  레벨업 1회 = 구매 최대 3회. 리롤은 그 3회에 포함되지 않는다(가격이 제약).
//   4-4  가격 배율 ×1.6 → 하향(정확한 값은 headless ③ 역산).
//   5-9  재시도 시 스폰 −15% 누적(기도).
//   7-2  N22 = 구출 밤. 3배 필드 + 양 1마리 + 6:40 패널 / 10:00 자동 발견.
//
// ■ **【2026-07-28】 10-A 실측 확정값을 기본값으로 박았다.** 더는 스윕 파라미터가 아니다.
//   · 안정성 판정 반경 **16유닛** (구 12 스윕 기준점)            → STAB.radius
//   · 안정성 계수 **0.000900** (구 5장 정본 0.00045의 ×2.00)     → STAB.coef
//   · 안정성 상한 **0.15** (구 5장 정본 0.125)                    → STAB.cap
//   · 플레이어 HP **1000** (구 4장 정본 100)                      → PLAYER.hp
//   · 스폰 곡선 = 10-A 확정 ① 표 (밤별 예산·상한)                 → SPAWN_MULT / NIGHTS[].spawnMult
//   구 「N3 스폰 ×1.4」(6-10)는 **폐기**되어 이 표의 N3 ×2.58에 흡수됐다.
//   **이 네 상수는 이제 명세 4·5장 정본과 다르다.** 회색박스가 문서를 앞선 상태이며,
//   문서 쪽 반영은 이 회색박스 밖의 작업이다(0-1 규율 4 — 수치 정본은 명세 + 산출기).
//
// 모든 수치는 시스템명세 v1.4 + tools/economy_gen.mjs(원장 정본, v2.0)에서 가져온다.
// 정본에 없는 값은 반드시 `임의값 — 미검증` 으로 표시한다.

export const UNIT = 32;            // 1 월드유닛 = 양 몸길이 = 32px (시스템명세 2장)
// 10분 개편의 시간축은 직전 12분 정본에서만 유도한다. 이 비율을 한 곳에 두어
// 특수 사건과 캠페인 총량이 서로 다른 반올림/상수를 갖지 않게 한다.
export const NIGHT_BASE_SEC = 12 * 60;
export const NIGHT_SEC = 10 * 60;
export const NIGHT_DURATION_RATIO = NIGHT_SEC / NIGHT_BASE_SEC; // 5/6

// ── 무기 — **물맷돌 하나** ──────────────────────────────────────
// 6-1 기준 DPS 계약. 계약의 압력 검산은 **무기 1종 + 개**이지 둘의 합이 아니다:
//   N1  요구 0.39/초 ← 공급 = 물매 1.5 + 개 2마리 0.84 = 2.34/초
export const PASU = { rate: 1.5, dmg: 10, range: 13.5 * UNIT };   // 단일 표적 → 1.5킬/초
// 【2026-07-31】 지팡이 상수(BANG)와 밀집도 함수(sweepTargets)가 여기 있었다 —
//   **무기 삭제**(사장님 결정: 무기는 물맷돌 하나). 근접 광역의 자리는 차돌(궤도)이 잇는다.

// minGap — **두 마리가 절대 겹치지 않는 최소 간격.** 6-1 계약 밖의 연출값(육안 판정).
//   구 구현은 둘 다 「가장 가까운 비물량층」을 물었고, 그러면 표적이 늘 같아서
//   한번 겹친 뒤로는 밤이 끝날 때까지 한 몸으로 다녔다 — 화면에서 개가 한 마리가 된다.
// slots·kinds 는 고정 목양견 서리·바람 두 마리의 정본이다.
export const DOG = { dps: 6, duty: 0.70, speed: 190, detect: 20 * UNIT, minGap: 2.2 * UNIT,
                     slots: 2, kinds: ['seori', 'baram'],
  // ══════════════════════════════════════════════════════════════
  //  ⚠⚠ **개가 잡몹보다 작았다** — 【사장님 지시 2026-07-30】
  //     *"이게 몹인지 내편인지 모른다고. 나는 알지만 다른 유저들은 모를수도 있어."*
  //
  //  실측 원인: 화면 배율이 **적 1.5 : 개 1.0** 이었다.
  //      적   `scene.enemyScale = artScale × enemyMul(1.5)`
  //      개   `ART = artScale` (배수 없음)
  //    둘 다 셀 48px 인데 적만 1.5배였으니, **잡몹이 내 개보다 컸다.**
  //    크기가 이 게임의 정보 채널이라(명세 6장 *"크기 = 정보"*) 그 채널이
  //    거꾸로 말하고 있었다 — 큰 쪽이 적이라고 배운 눈에 개가 작게 보인 것이다.
  //
  //  **먼저 1.7 로 올렸다** — 「잡몹보다 크고 정예보다 작은」 자리. 그런데 실플레이에서
//    **너무 컸다**(사장님). → **×0.8 = 1.36.** artScale 1.3 기준 실제 화면 크기:
  //        물량층 94px  ·  **개 85px**  ·  정예 125px
  //  ⚠ **1.36 은 잡몹(94px)보다 9% 작다.** 크기 채널만으로는 더 이상 안 갈린다는 뜻이고,
  //    구분은 **발밑 광원**(DOGFX)이 혼자 진다. 그 광원이 실제로 그 일을 하는 것을
  //    확인한 뒤에 줄인 것이다 — 광원을 끄면 이 값은 다시 올려야 한다.
  //  ⚠ 더 줄이지 마라. 2/3(1.13 = 71px)까지 내리면 잡몹보다 **25%** 작아져
  //    「크기 = 정보」 채널이 **거꾸로** 말하기 시작한다(작은 것이 내 편이 된다).
  //  ⚠ **판정은 하나도 안 따라 커진다** — `DOG.detect`·`minGap`·`dps` 전부 그대로다.
  //    그림만 커진다(`artScale` 주석의 계약과 같다).
  artMul: 1.36,
};

// ── 개 — **그림 채널.** 판정이 아니다   【2026-07-30 신설】 ──────
//  ■ **왜 개의 공격이 화면에 하나도 안 보였나.** `world.moveDogs` 가
//    `tgt.hp -= dogDmg * dt` 로 **hp 를 직접 깎는다** — `damageEnemy()` 를 안 거치므로
//    타격 섬광(`e.hitT`)·피해 숫자·피가 **한 번도 안 뜬다.** 개가 일하는 것이
//    화면 어디에도 안 나타났고, 그래서 「배경」으로 보였다.
//  ■ **판정을 건드리지 않고 고친다.** dps 는 지금처럼 연속으로 들어가고,
//    화면에만 **물기 주기**를 준다 — 계속 갉는 것이 아니라 **주기적으로 문다**로 보인다.
//    (연속 섬광은 정보가 아니라 소음이다. 리듬이 있어야 「물었다」가 읽힌다.)
//  ⚠ 값은 **전부 잠정**이다 — 화면 상수이므로 경제 재수렴과 무관하다.
export const DOGFX = {
  bite:   0.30,   // ⚠【잠정】 물기 **표시** 주기(초). 피해는 여전히 연속이다
  hold:   0.18,   // ⚠【잠정】 무는 프레임이 서 있는 시간(구 `d.attack = 0.18` 그대로)
  arc:    1.15,   // ⚠【잠정】 물어뜯는 호의 각(라디안)
  reach:  1.05,   // ⚠【잠정】 그 호의 반경(유닛)
  ally:   0x8fd0ff,   // **아군 색.** 새 색을 만들지 않는다 — 개 짖음 고리가 쓰던 그 색이다
  // ── 발밑 광원 ───────────────────────────────────────────────
  //  ⚠⚠ **처음 값(반지름 15 · 밝기 0.30)은 화면에서 안 보였다.** 실측으로 원인 둘:
  //    ① 개 스프라이트가 48 × dogScale 2.21 = **약 106px** 인데 고리 지름이 66px 라
  //       **통째로 스프라이트 뒤에 들어갔다.**
  //    ② 실제 칠해진 밝기가 `mark × 0.34 × breathe` = **0.09** 였다. 안 보이는 게 맞다.
  //  → **개보다 커야 개를 가리킨다.** 반지름을 34(지름 150px ≈ 개의 1.4배)로 올리고
  //    밝기도 올린다. 모양은 **플레이어 발밑 광원과 같은 문법**(부드러운 타원)이다 —
  //    적에게는 이것이 없으므로 *"발밑이 빛나는 것은 배우다"* 가 규칙이 된다.
  markR:  34,     // ⚠【잠정】 발밑 광원 반지름(그림 단위 × artScale × dogMul)
  mark:   0.55,   // ⚠【잠정】 그 밝기
  edge:   3.0,    // ⚠【잠정】 무는 호의 최대 굵기(px × artScale)
};

// ── 적 3층 — 크기 × 이동 패턴 × **행동** ────────────────────────
// ■ **【10-B 6-1】 「행동」 축 신설.** 구 회색박스는 전 개체가 **최단거리 직진**이었다.
//   그러면 적의 종류가 「빠르냐 / 질기냐 / 아프냐」 세 숫자로만 갈리고, 플레이어가
//   **다르게 대응할 이유가 없다** — 어차피 다 도망치면 된다. 상용 뱀서는 적마다
//   대응이 다르고, 그 대응을 배우는 것이 성장이다.
//   곰의 「땅 긁기 1.5초 → 돌진」(명세 6-2)이 이미 이 문법이다. 보스 전용이던 것을
//   일반 적에 내린다 — **보스는 문법의 발명이 아니라 확대여야 한다.**
export const ENEMY = {
  // 물량층 — **직진.** 물량은 흐름이다(6장 "끊기지 않는 흐름"). 벽을 만들 뿐 수를 쓰지 않는다.
  swarm:  { hp: 10, speed: 62,  drop: 1.37, r: 9,  act: 'straight', knock: 0 },
  // 정예층(늑대·우두머리) — **선회.** 정면으로 오지 않고 궤도를 돌며 조인다.
  //   배우는 것: **등 뒤를 신경 쓴다.** 가장 가까운 적만 보고 도망치면 반대편이 닫힌다.
  elite:  { hp: 30, speed: 54,  drop: 10,   r: 13, act: 'circle',   knock: 0 },
  // 하이에나 — **돌진.** 예고 1초 뒤 3배속. 배우는 것: **예고를 보고 옆으로 비킨다.**
  //   N12 카드가 "예고 없는 정예"인 것과 충돌하지 않는다 — 그 카드가 없앤 것은
  //   **밤 단위 예고(하울링)**이고, 이것은 **순간 단위 예고**다. 자가 다르다.
  //   넉백은 명세 4장 "넉백은 하이에나·곰·사자만"의 구현이다(늑대에는 없다).
  hyena:  { hp: 40, speed: 76,  drop: 10,   r: 14, act: 'charge',   knock: 1.6 * UNIT },
};
export const GRASSHOPPER = Object.freeze({
  phaseSec: 0.2,
  cycleSec: 0.8,
  leapSpeedMul: 4,
  visualLift: 12,
});
export const EAGLE = Object.freeze({
  hp: 20,
  r: 48,
  highSec: 3.5,
  lowSec: 1.5,
  warningSec: 5,
  groundSec: 1.5,
  takeoffSec: 1,
  airDamageMul: 1,
  groundDamageMul: 3,
  drop: 30,
});
// 화면에서 같은 점처럼 겹치는 것을 풀되, 한 프레임의 이웃 검사는 반드시 유한하게 둔다.
// `gap` 은 판정 몸집을 키우지 않고 분리 단계에서만 쓰는 시각적 여백이다.
export const ENEMY_SEPARATION = {
  gap: 6,
  maxDistance: 0.98 * UNIT,  // 3×3 격자 이웃 안에서 끝나도록 한 칸보다 작게
  maxPush: 3,                // 한 프레임 순간이동을 막는 부드러운 보정 상한(px)
  maxChecks: 32,             // 최악에도 O(적 수 × 32)
};
// 행동 계수 — **전부 측정 대기(10-B 6-1).** 아래는 탐색 시작점이다.
export const ACT = {
  charge: {
    range: 7 * UNIT,    // 이 거리 안에 들면 돌진 준비
    tell:  1.0,         // 예고(정지) 시간. **이 값이 곧 난이도다** — 짧으면 반응 불가
    mult:  3.0,         // 돌진 중 이속 배수
    dist:  3 * UNIT,    // 돌진 거리
    cool:  3.0,         // 재돌진 간격
  },
  circle: {
    orbit:   6 * UNIT,  // 이 거리부터 궤도를 돈다
    tangent: 0.85,      // 접선 성분 비중(0 = 직진, 1 = 순수 공전)
  },
};

// ── 4장 플레이어 HP ─────────────────────────────────────────────
// **hp = 1000. 10-A 확정 ③.** 구 값 100(4장 정본)과 직전 차수의 후보 650을 대체한다.
// 구속 밤은 **N22·N23 근딜**이었다 — 10-A 확정 ① 스폰 곡선에서 그 두 밤의 누적 피해가
// 가장 크다. 임의값이 아니라 지시서가 박아 준 값이다.
//
// **3-1 이후 중요한 성질**: 안정성이 더는 피격을 읽지 않으므로 **HP는 시뮬레이션에
//   전혀 되먹임되지 않는다.** 봇 정책도 HP를 안 본다. 따라서 HP를 무한대로 두고 한 번
//   돌리면 그 런의 누적 피해 궤적이 나오고, 임의의 HP에 대한 생사는 그 궤적에서
//   **해석적으로** 판정된다(headless ②). 스윕이 아니라 정확 계산이다.
//   → 그래서 hp를 1000으로 박아도 ②의 완주율 재검증은 여전히 정확 계산이다.
//
// ■ **【2026-07-28 10-B 1】 HP 1000 → 350. 위험을 되돌린다.**
//   1000에서 정예 접촉 10뎀은 HP의 **1.0%**다. 실측 밤당 피격 **314회**.
//   100번 맞아야 죽는 게임에서 **회피할 이유가 없다** — 회피 생존인데 회피가 무의미했다.
//   그리고 그것이 두 무기가 안 갈리던 진짜 이유다: 근딜 처치 상한이 원딜의 1.60배인데
//   **붙는 대가가 0**이라 그 1.6배가 그대로 이득이 됐다.
//   350에서 정예 접촉은 **2.9%**(34회면 죽는다) — 물량 접촉은 0.29%다.
//   *스치는 건 안 아프고 눌러앉으면 죽는다.* N3 카드 "큰 놈은 아프다"가 여기서 처음 성립한다.
//
//   **완주율(6-5)은 HP 덩치가 아니라 회복으로 산다** — 아래 WATER. 명세 4장의
//   「회복 3체제」 ①이 `측정 대기`로 비어 있던 자리이며, 10-B가 그것을 채운다.
export const PLAYER = { hp: 350, speed: 210, iframe: 0.5,
                        // ── 【사장님 결정 2026-07-29】 몹 피해 ×10 ──────────────
                        // 실플레이에서 **안 죽는데 물량이 안 준다**는 것이 드러났다.
                        // 물량이 위험이 아니면 회피가 의미를 잃고, 무기에 광역을
                        // 넣는 것도 대가 없는 이득이 된다. **붙어 있는 것이 아프게** 만든다.
                        // 회전 광역(SLING.ORBIT)이 붙는 자리가 정확히 「붙어 있는 거리」라
                        // 이 둘은 한 벌이다 — 광역을 쓰려면 위험을 감수해야 한다.
                        dmgSwarm: 10, dmgElite: 100, r: 0.4 * UNIT,
                        // ── 【10-B 2-3】 조각 흡수 반경 = **원딜 사거리** ──────
                        // 구 값 2.5유닛은 *"임의값 — 미검증"*으로 박혀 있었고, 실측에서
                        // 그것이 무기 균형을 통째로 깨고 있었다:
                        //   밤당 레벨업 — **원딜 5~7회 / 근딜 19~36회**(목표 12~15)
                        // 원딜은 13.5유닛 밖에서 죽이는데 흡수는 2.5유닛이라 **자기가 잡은
                        // 것을 못 줍는다.** 근딜은 5유닛 안에서 죽이니 전부 줍는다.
                        // 그러면 "안 맞으려고 멀리서 쏘는" 무기의 정체성이 **스스로를 굶긴다.**
                        // → **내 사거리 안에서 죽은 것은 내 것이다.** 흡수 반경을 원딜
                        //   사거리에 맞춘다. 뱀서류의 자석 픽업과 같은 문법이고,
                        //   8장 「그러모으기(+40%)」가 붙을 기준값도 이제 근거를 갖는다.
  // ⚠ **사장님 지시로 13.5 → 9.0 유닛(2/3).** 이것이 10-B 2-3의 항등식을 깬다:
  //   *"내 사거리 안에서 죽은 것은 내 것이다"* — 흡수 반경 = 물맷돌 사거리(13.5)였다.
  //   그 항등식이 「그러모으기」와 「팔을 크게 돌린다」가 붙을 기준이었으므로, 두 카드는
  //   여전히 배율로 작동하되 **기준이 사거리에서 떨어져 나왔다.** 경제 총량은 안 흔들린다
  //   (밤 종료 시 잔여 조각 전량 회수 — A19). 흔들리는 것은 **밤 중 레벨업 속도**이고,
  //   그것은 n(t)가 실제 회수율을 읽으므로 자기보정된다(config.LEVEL_CURVE).
                        pickup: 9.0 * UNIT };

// ── 종별 근접 공격 ─────────────────────────────────────────────
// 이동과 접촉이 같은 것이면 수천 마리의 몸이 모두 상시 공격 판정이 되고, 종별
// 몸짓은 장식으로 끝난다. 일반 적의 몸은 접근 중에는 무해하며 아래 짧은 commit만
// 공격이다. 피해량은 새 표를 만들지 않고 기존 `PLAYER.dmgSwarm/dmgElite`를 그대로
// 쓴다. 시간·거리도 이미 플레이에서 검증 중인 네 자만 재사용한다:
//   메뚜기 한 위상(0.2초) · 다윗 무적창(0.5초) · 한 몸길이(UNIT)
//   하이에나 돌진 속도/거리/재사용(ACT.charge)
// localCap = floor(무적창/한 위상) = 2. 한 무적창 안에 셋 이상이 동시에 물어도
// 피해는 늘지 않고 화면만 더러워지므로, 근거리 몸 공격은 최대 둘만 허용한다.
export const GROUND_ATTACK = Object.freeze({
  localCap: Math.max(1, Math.floor(PLAYER.iframe / GRASSHOPPER.phaseSec)),
  leadSec: UNIT / PLAYER.speed,
  staggerSec: GRASSHOPPER.phaseSec,
  holdGap: UNIT / 2,
  rat: Object.freeze({
    tellSec: GRASSHOPPER.phaseSec,
    distance: UNIT,
    speedMul: ACT.charge.mult,
    recoverSec: PLAYER.iframe,
    retreatDistance: UNIT,
    cooldownSec: ACT.charge.cool,
  }),
  wolf: Object.freeze({
    tellSec: PLAYER.iframe,
    distance: ACT.charge.dist,
    speedMul: ACT.charge.mult,
    recoverSec: PLAYER.iframe,
    retreatDistance: UNIT,
    cooldownSec: ACT.charge.cool,
  }),
  dog: Object.freeze({
    tellSec: GRASSHOPPER.phaseSec,
    distance: UNIT,
    speedMul: ACT.charge.mult,
    recoverSec: PLAYER.iframe,
    retreatDistance: UNIT,
    cooldownSec: ACT.charge.cool,
  }),
  jackal: Object.freeze({ overshoot: UNIT }),
  grasshopper: Object.freeze({ kickReach: UNIT }),
  bat: Object.freeze({
    tellShare: 0.25,
    commitShare: 0.50,
    recoverShare: 0.25,
    cooldownSec: ACT.charge.cool,
  }),
  eagle: Object.freeze({
    // 기존 low 1.5초의 후반 절반에서 다리를 펴고, 착지점 앞을 두 발로
    // 긁는다. 새 피해·새 시간표 없이 기존 독수리 창/돌진 거리/몸 자만 쓴다.
    signalSec: EAGLE.lowSec / 2,
    rakeBack: UNIT / 2,
    rakeReach: ACT.charge.dist,
    talonGap: UNIT,
    talonRadius: PLAYER.r / 2,
  }),
});

// ── 【10-B 1】 회복 = 「물웅덩이」 ────────────────────────────
// 명세 4장 「회복 3체제」 ①은 *"랜덤 드롭 우유 — 드롭률·회복량 `측정 대기`.
// **디제시스 근거(무엇이 우유를 떨구는가)도 함께 정한다** — 조각과 달리 이 픽업은
// 아직 출처가 없다"*로 비어 있었다(명세 11장 미결 4). 10-B가 그 질문에 답한다.
//
// ■ **답: 아무것도 떨구지 않는다. 회복은 물건이 아니라 장소다.**
//   · **디제시스** — 목자는 밤에 물이 어디 있는지 안다. 늑대가 우유를 떨어뜨릴 이유는
//     끝내 없지만, **들에 물웅덩이가 있을 이유는 설명이 필요 없다.**
//     출처 없는 픽업이라는 문제 자체가 사라진다.
//   · ⚠ **이름 주의** — 처음 붙였던 「쉴 만한 물가」는 **시편 23:2 본문 그대로**였고,
//     서사바이블 6장 「암시 규칙」(불가침)이 *"무대명·챕터명·업적명·일기 어디에도
//     시편 어구를 옮기지 않는다"*고 못박는다. **화면에 나가는 이름은 「물웅덩이」다.**
//     기제가 성경을 닮는 것은 좋고, 성경을 인용하는 것은 안 된다.
//   · **명명 충돌 해소** — 「우유」는 낮 수입의 이름이고 불변식 ②(전투:우유 밴드)가
//     그 이름 위에 서 있다. 밤 회복을 같은 이름으로 부르면 두 개가 한 단어를 쓴다.
//     밤 회복은 **물**이다. 경제 정본을 한 글자도 건드리지 않는다.
//   · **게임 설계** — 랜덤 드롭은 회복을 **처치량의 함수**로 만든다. 그러면 더 많이
//     죽이는 근딜이 회복까지 더 받아 10-B 0-② 진단(근딜 전 구간 우세)이 재발한다.
//     고정 위치 + 쿨다운은 회복을 **이동의 함수**로 만든다 — 붙어 있어야 딜이 나오는
//     근딜에게 물가까지 가는 왕복이 실제 비용이 된다. **이것이 두 무기의 분기다.**
//   · 그리고 지금 밤의 필드는 **아무 의미가 없다**(빈 사각형). 물가가 필드에 처음으로
//     지형적 의미를 준다 — 갈 곳이 생기고, 그 갈 곳이 붐빌 수 있다.
//
// ■ 규칙
//   · 밤마다 `count`개가 필드에 고정 배치된다(시드 고정 — 그 밤은 항상 같은 자리).
//   · 반경 안에 들어가면 **자동으로 마신다**(입력은 이동 하나 — 2-1 불가침).
//   · 마시면 그 샘은 `cooldown`초 마른다. 연속으로 두 번 못 마신다.
//   · 회복량 = 최대 HP의 `heal` 비율. **HP 비율이므로 HP를 조정해도 관계가 유지된다.**
//   · **적은 물가를 신경 쓰지 않는다** — 전부 플레이어에게 직진한다(2-4 불가침).
//     물가가 위험한 이유는 적이 지키기 때문이 아니라 **거기 가는 동안 뒤를 보이기** 때문이다.
//
// count·heal·cooldown 은 전부 **측정 대기(10-B 1)** — headless_sss.mjs ①이 6-5 완주율
// (비허용 26밤 90%+ / 죽을 수 있는 밤 N17·28·29·30)을 만족하는 최소 밀도를 찾는다.
// ■ **【10-B 확정】 4곳 · 반경 1.2유닛 · 회복 20% · 쿨 45초.**
//   밀도 스윕(4/45 · 3/60 · 2/60 · 2/90) 결과 **줄이면 양쪽 다 나빠진다**:
//     4/45 음용 상계 10.9 / 하계 8.7 · 완주(회복 25%) 100 / 89
//     2/90 음용 상계  5.8 / 하계 3.8 · 완주(회복 25%)  61 / 56  ← 격차까지 사라진다
//   샘을 줄이면 「찾아가는 플레이」가 보상받는 게 아니라 **왕복 시간이 손해로만 남는다** —
//   가는 동안 맞기 때문이다. 그래서 4곳을 유지한다.
//   **회복 30% = 350의 105.** 밤당 ~11회면 1,155 = **최대 HP의 3.3배를 밤새 되돌린다.**
//   확인 런에서 20%는 완주율 81%로 6-5 판정선(90%)에 미달했다 — 최종 확정값(근딜 cap 4.6 ·
//   계수 0.00045)에서 다시 재니 밤이 더 아팠기 때문이다. 30%에서 **94%**.
//   한 모금이 체력바의 1/3을 되돌리는 것은 뱀서 문법 그대로다 — **크게 읽히는 회복**이라야
//   「거기로 간다」는 결정이 결정처럼 느껴진다.
//   ⚠ **「무시하면 죽는다」는 아직 실측으로 못 세웠다** — 상계 94% / 하계 93%로 거의 같다.
//     도주 봇도 필드를 넓게 훑어서 우연히 밟기 때문이다. 사람이 쳐 봐야 갈린다(명세 4-2).
export const WATER = {
  on: true,
  // ══════════════════════════════════════════════════════════════
  //  **우물은 들판 전체에 깔린다 — 화면 한 칸당 셋** 【사장님 지시 2026-08-07】
  //    *"한 화면에 3개씩 있되 … 총 맵에는 3×n개. 모든 우물이 연동이 아니라
  //      한 필드에 3개 우물을 가,나,다 라고 쳤을때 가끼리, 나끼리, 다끼리 연동"*
  //
  //  ■ 벽이 없으므로 **n 은 무한**이다(사장님 확정 A안). 화면 크기(FIELD.viewW×viewH)
  //    격자로 끝없이 타일링하고, 칸마다 가·나·다 셋을 놓는다.
  //  ■ 연동은 **자리별**이다 — 모든 칸의 「가」끼리 쿨다운을 공유한다.
  //    ⇒ 어디로 도망가도 근처에 셋은 있지만 **40초당 총 3모금**이 상한이다.
  //      다음 화면으로 뛰어도 그쪽 「가」는 이미 말라 있다. 이것이 요점이다.
  //  ■ ⚠ **마름은 우물 개체가 아니라 그룹이 든다**(world.waterDry[3]). 멀어진 칸은
  //    버려졌다가 다시 만들어지므로, 개체가 들면 왕복 한 번에 쿨다운이 리셋된다.
  //  ■ 구 판(2026-08-04)은 **시작 화면 한 칸에만** 셋을 놓고 셋을 통째로 묶었다
  //    (45초당 1모금 · 멀리 나가면 물이 아예 없음). 그 판은 폐기됐다.
  //  ⚠ 회복 총량이 1모금 → 3모금/40초로 늘었다. heal 0.30 의 「완주 94%」는
  //    구 10-B 전제(4개·독립·한 칸)의 측정이므로 **완주율 재측정 대기** — 명세 4-2.
  //
  //  ⚠ **접촉 즉시 음용으로 결정**【2026-08-10】. 아래 구 실측은 경제 재조정 때 참고한다.
  //        우물 1모금/45초 → 도망 3.4분 · 싸움 4.1분   ✓ 싸움이 낫다
  //        우물 3모금/45초 → 도망 4.4분 · 싸움 4.2분   ⚠ **도망이 더 오래 산다**
  //      싸움은 4.1→4.2 로 거의 그대로다(둘러싸인 사람은 우물을 순회할 수 없다).
  //      도망만 3.4→4.4 로 벌었다 — 달리는 내내 우물을 밟기 때문이다.
  //      구 판에서 「시작 칸에만 깐다」가 **무한 도망에 값을 매기던 유일한 자리**였고,
  //      그 자리가 없어지면서 사장님이 2026-08-02 에 막은 구멍이 다시 열렸다
  //      (*"그냥 계속 도망가면 클리어 될거같은데"* → runBias·runSpawnMul).
  //      ⇒ `density_check` 의 「도망이 최선의 수가 되면 안 된다」가 이 변경으로 깨졌다.
  //      조작감은 즉시 음용을 우선한다. 도주 경제가 다시 문제면 cooldown 또는
  //      FIELD.runSpawnMul 쪽에서 조정하고, 접촉 판정을 지연시키지는 않는다.
  // ══════════════════════════════════════════════════════════════
  perCell: 3,           // 화면 한 칸당 우물 수 = 연동 묶음 수(가·나·다)
  radius: 1.2 * UNIT,   // 마시는 반경. 플레이어 반지름 0.4 + 여유
  heal: 0.30,           // 10-B 확정 — ⚠ 측정 전제가 위와 같이 바뀌었다
  cooldown: 40,         // 재생성 간격 정본. 개체가 아니라 자리별 연동 그룹이 드는 값이다
  // 【2026-08-10】 반경에 스치기만 해도 첫 접촉 프레임에 마신다.
  //   풀피 미소모와 자리별 40초 연동 쿨다운은 그대로라서, 실제로 회복했을 때만 마른다.
  sipDwell: 0,
  margin: 12 * UNIT,    // 여백 상한. 실제로는 띠 폭·칸 높이에 맞춰 더 작게 잘린다(아래)
  // ⚠ **`minGap` 은 더 이상 우물끼리의 자가 아니다** 【2026-08-07】. 구 판은 이 값으로
  //   기각 표집을 돌렸는데 자리가 없어 거의 늘 실패했고(실측 75쌍 중 33쌍 위반),
  //   결국 아무 데나 놓였다. 이제 `cellWater` 가 **칸을 세로 띠 3개로 나눠 하나씩**
  //   놓으므로 몰림은 **구조로** 막힌다(실측 최소 402px · 동시 음용 문턱 102px의 4배).
  //   남은 쓰임은 **하나** — 다윗이 선 자리에서 이만큼은 떨어뜨린다.
  minGap: 18 * UNIT,
};

// ── 5장 안정성 — **3-1 확정본 + 10-A 확정 ② 3값.** ──────────────
//   감소 = **반경 내 적 수** × 0.000900%p/초 × 무리 배율   (상한 0.15%p/초 × 배율)
//   회복 = 반경 내 적 없을 때 +0.3%p/초  · 판정 반경 **16유닛**
//   **피격 항 없음.** 피격은 HP만 깎는다.
//   무리 배율 = 1 + (무리 수 − 20) / 60
//
// **피격 항을 왜 지웠는가 (3-1 확정)** — 직전 측정(7e15fa7)의 실측:
//   연속 항의 밤 전체 상한 = 0.125 × 1.1(N12 배율) × 720초 = 99%p
//   이산 항(피격 −1%p) 실측 = N12·HP600·human에서 밤당 202~210회 = 202~210%p
//   이산 항이 연속 항의 **2.2배**. 명세 5장은 이벤트 감소를 "상한 밖 별도 가산"
//   (= 보조 항)으로 규정하는데 HP를 6배로 올린 순간 관계가 역전돼 안정성이
//   압력 게이지가 아니라 **피격 카운터**가 됐다. 3-1이 이 항을 폐기했다.
//   > **HP = 사고(맞았다) / 안정성 = 자세(위험한 데 있었다)**  ← 3-2
//
// **【2026-07-28 10-A 확정 ②】 세 값이 함께 확정됐다 — 따로 떼어 읽지 마라.**
//   > 판정 반경 **16유닛** · 계수 **0.000900**(구 정본 0.00045의 ×2.00) · 상한 **0.15**
//   → 10-A 기재 RMSE 3.71%p · 전투 밤 평균 78.2%(목표 77)
//
// radius 16유닛 — 3-4 `측정 대기`의 해답. 구 12유닛은 13-2 개 자동 모드에서 승계한
//   근거 없는 값이었고, 구 차수의 반경 스윕은 계수를 0.00045에 고정한 탓에 60~70유닛
//   근처에서 RMSE가 포화했다. 계수를 함께 푸니 **반경이 70 → 16으로 내려왔고**
//   그 덕에 **회복 규칙이 다시 산다**(고요 비율 0.9% → 7.4%).
//   반경이 유한하다는 것이 원장 산출기와의 구조 차이인데(산출기는 동시 개체 전부를 N에
//   넣고 앞120초·뒤60초를 고정 고요 액자로 둔다), 10-A 확정 ④가 그 두 가정이 **둘 다
//   틀렸음**을 실측으로 보였다 — 반경 내/상한 18~56%, 고요 3.8~10.9%.
// coef 0.000900 — 스폰만 올리고 계수를 그대로 두면 평균 85.8%로 미달이었다.
//   구 스폰에서는 ×3.75~×8이 필요했는데 **물량이 압력을 대신 만들어 ×2로 줄었다.**
// cap 0.15 — 구 0.125는 후반 밤을 뭉갠다(10-A 미해결 ③). 0.15가 그 완화값이며,
//   완전히 풀리지는 않았다 — 재검증 항목이다.
// ■ **【2026-07-28 10-B B-3】 계수가 v1 정본값으로 되돌아왔다.**
//   10-A ②는 계수를 0.00045 → 0.000900(×2.00)으로 올렸다. 근거는 *"스폰만 올리고 계수를
//   그대로 두면 평균 85.8%로 미달"*이었는데, **그 미달의 정체가 「빈 화면」이었다** —
//   당시 회색박스는 레벨업을 무기에 안 먹였고, 그래서 진척을 켜자 화면 개체가
//   N8 115 → 31로 무너져 있었다. 적이 없으니 압력이 모자랐고, 계수를 두 배로 올려
//   **없는 적의 몫을 있는 적에게 얹고 있었던 것**이다.
//   밴드(헌법 5조)를 먼저 채우고 다시 적합하니 **계수가 정확히 구 정본 0.00045로 돌아왔다.**
//   → RMSE **3.75%p** · 전투 밤 평균 **76.5%**(목표 77) · 10밤 전부 밴드 안.
//   상한만 0.125 → **0.18**로 오른다(후반 밤이 상한에 21~28% 붙는다 — 그것이 후반의 성격이다).
// ══════════════════════════════════════════════════════════════════
//  【10-D 라이브 재적합 2026-08-04 — 40일 직선 곡선(94 − 1.0/전투밤)에 맞춘 값】
//    · 적합 절차: headless_coef 3차원 스윕(순위용) → **probe_curve_live 라이브 실측**(확정).
//      재적분 절대값은 저계수 영역에서 +9~+24%p 편향이라 최종 자로 쓰지 않았다(도구 주석).
//    · 라이브 잔차(앵커 9밤 · 실게임 스폰 · 시드 4 확정): **N1 −0.5 · N15 −0.3 · N30 +0.4**
//      — 사장님 보정 밤(N1)과 무거운 두 밤이 전부 반 점 안에 앉는다. RMSE 8.41.
//    · 남는 잔차는 전부 +방향(8~23일 +5~+15.8, 피크 20·23일): **카드 압력이 직선보다
//      무른 구간**이다. 상수로 못 닫는다 — 해소는 카드 구성(30밤시트) 소관, 잔차는 보고.
//    · 반경 12 = 라이브 실측 승자. 5유닛은 가벼운 밤에서 계기가 죽고(잘 도는 봇 주변은
//      빈 공간 — 전 밤 97~99), 16유닛(10-A ②)은 구압력 시절 값이다.
//    · ⚠ 고요(반경 빈 시간) 1.5~2.0% — 실압력에서 5장의 회복 규칙이 사실상 침묵한다.
//      규칙 개정(「0마리」→「N마리 이하」) 여부는 명세 사안 — 12장 미결 ⓕ.
export const STAB = {
  coef: 0.0004,       // 10-D 라이브 재적합 (구 0.001130 — 30밤·구압력 적합값)
  cap: 0.10,          // 10-D 라이브 재적합 — N30 꼬리를 목표(69)에 앉히는 값 (구 0.18)
  rec: 0.3,           // 5장 정본 — 반경 내 적 없을 때 (미변경)
  flockDiv: 60,       // 5장 정본 — 무리 배율 = 1 + (무리−20)/60 (미변경)
  radius: 12 * UNIT,  // 10-D 라이브 재적합 (구 16 = 10-A ② — 구압력 시절 확정)
  panicOut: 20,       // 5장 "20% 회복 시 정상화" (미변경)
};
// 구 정본 계수 — **역산 스크립트(headless_coef.mjs)의 ×배수 축을 과거 차수와 같은 자
// 위에 두기 위해서만** 남긴다. 게임 규칙은 위 STAB.coef 하나뿐이다.
export const STAB_COEF_LEGACY = 0.00045;

// ── 조각 · 자동 레벨업 (4-2·4-5·4-6) ────────────────────────────
// **새 재화는 없다(4-5).** 픽업은 기존 「조각」 하나뿐이고 조각이 두 가지 일을 한다 —
//   ⓐ 16조각 = 치즈 1(불변식 ①, 낮으로 이월)  ⓑ 조각 누적이 레벨 게이지를 채운다.
// 드랍값 = 명세 6장 정본 그대로. 건드리지 않는다.
//   물량층 평균 1.37조각 / 정예 10 / 위협 clamp(HP×1.5, 30, 150)
//   하이에나는 6-1 3층 구조상 **정예층**이므로 10.
// ■ **환율 10 → 16 (【10-B】).** 산출기(`tools/economy_gen.mjs` `pieceToCheese: 16`)가
//   불변식 ②④에서 역산한 값인데 회색박스에는 안 들어와 있었다 — 두 쪽이 서로 다른 환율로
//   같은 지갑을 계산하고 있었다. 구 10은 10-A가 적 수를 3배로 올린 뒤 지갑까지 3배로
//   부풀렸다. **드랍값이 아니라 환율만 움직인다** — 명세 6-1 드랍 정본은 그대로다.
export const PIECE = { swarm: 1.37, elite: 10, hyena: 10, perCheese: 40 };

// 4-6: **조각 회수는 밤 종료 시점 100%**(구 "새벽 자동"). 하루는 낮 ↔ 밤 2박자다.
export const SWEEP_AT_END = 1.0;

// ── 레벨 요구량 곡선 ────────────────────────────────────────────
// **11절 「조각당 레벨업 요구량 n」 — 측정 대기 항목.** 두 형태를 다 구현해 ③에서 대조한다.
//
// (A) flat — **산출기 v2.0 정본.** n은 밤 안에서 상수다.
//     step(밤) = max(10, 10 × round(그 밤 조각 총량 / 13.5 / 10))  → N1 30 … N30 460
//     `tools/economy_gen.mjs levelStepOf()`를 그대로 옮긴 것이다. 임의값 없음.
// (B) rising — 직전 회색박스가 쓰던 형태. 레벨이 오를수록 요구량이 는다(뱀서 관례).
//     req(L,밤) = round(scale(밤) × (1 + REQ_STEP × (L−1)))
//     **REQ_STEP 0.375는 임의값 — 미검증.** 총 횟수가 아니라 밤 안의 간격 분포만 정한다.
//
// **기본값은 flat이다** — 수치 정본이 산출기이고(0-1 규율 4), 직전 커밋 67da521이
// "다음 작업에서 회색박스를 평탄 n으로 맞출 것"이라 남겼다. (B)는 ③의 대조군으로만 산다.
// ── 【10-B 6-2b】 실측 재보정 레벨 요구량 ───────────────────────
// **구 `flatStep()` 은 원장 v2.0 의 `ledgerPieces` 로 요구량을 잡는데, 그 값이
// 10-A 이전 스폰 곡선의 산물이라 실제 수입과 어긋나 있었다.** 실측 레벨업 횟수:
//   N1 **30.3회** (4-4 목표 12~15의 2.2배) · N30 **7.0회** (목표의 0.5배)
//   즉 초반은 레벨업이 쏟아지고 후반은 말라 있었다 — 방향까지 반대였다.
// ⚠ **공식이 아니라 값이 문제였다.** 분모를 「밤 중에 주운 조각」으로 바꾸는 것은
//   정확성 교정이지 크기의 원인이 아니다 — 명세 6장이 적어 둔 *"쓸 수 없는 레벨업"*의
//   진짜 원인은 **흡수 반경**이었고(10-B 2-3), 그것은 원딜에만 걸리는 편향이었다
//   (밤중 픽업률 원딜 58% vs 근딜 89%). 반경 확정 후 86~100%가 되어 두 값이 거의 같아졌다.
// 아래 표는 **회색박스 실측 수입으로 반복해 수렴시킨 값**이다.
//   규칙은 산출기와 같다: step = max(10, 10 × round(밤 중 주운 조각 ÷ 13.5 ÷ 10))
//   단 분모가 원장 조각이 아니라 **밤 중에 실제로 주운 조각**이다 — 레벨업은 밤 안에서
//   열리고, 밤 끝 일괄 회수분(4-6)은 그 밤의 레벨을 못 올리기 때문이다.
//
// ── 【2026-07-28 재수렴 — 구 표(140~290)는 폐기한다】 ──────────────
// ⚠ **구 표는 스폰 배수를 올리기 *전*의 국면 A에서 수렴한 값이었다.**
//   그 수렴 당시 N1 스폰 ×4.52 → 최종 ×6.33(전 밤 1.25~1.9배 상승). 적이 늘었으니
//   조각도 늘고 레벨업도 늘었다. 구 주석이 *"이 값에서 밤당 레벨업 13.0~14.2회"*라
//   적어 두었는데 **그 문장은 거짓이었다** — 최종 스폰에서 같은 표를 먹인 회색박스가
//   실제로 낸 값은 **14.2~23.7회**다(10밤 중 6밤이 4-4 목표 12~15 밖, 소비율 79~95%).
//   환율 10 → 16 동기화도 같은 런에 들어 있다(구 표는 환율 10에서 수렴한 값이다).
//
// **과거 상태에서 다시 수렴시킨 값(시드 3 · 무기 2 · 반복 3, 2026-07-28).**
//   당시에는 이 표와 장별 정액 가격을 한 쌍으로 측정했다. 장별 정액은 2026-08-17에
//   결과 등급 가격으로 폐기됐고, 캠페인도 아래 90 기준 곡선을 쓰므로 이 값은 명시적
//   프로브 주입과 과거 근거로만 남는다. 당시 그 쌍에서 **실측된** 값:
//     밤당 레벨업 **13.0~14.8회** — 10밤 전부 4-4 목표(12~15) 안
//     카드 중첩 3.42~3.90(상한 5) · 구매/희망 = 100%(지갑이 3택을 다 감당한다)
//     밤 소비율 43~63% — **7/10밤만 불변식 ③(50~60) 안.** 아래 ⚠ 참조
// ⚠ **이 표는 「측정된 쌍」이지 「고정점」이 아니다.** 반복 3의 *출력*(N8 280 · N10 290 ·
//   N12 280 · N15 290 · N20 310 · N23 320 · N30 320)은 입력과 20~30 어긋나 있고,
//   **그 출력은 한 번도 측정된 적이 없다.** 측정된 쌍이 이미 목표 밴드(점이 아니라 밴드다)
//   안에 있으므로 **측정값을 정본으로 삼고 미측정 출력은 버린다.** N1·N3·N22는 입출력이
//   일치해 진짜 고정점이고, 나머지 6밤은 레벨업이 13.5보다 살짝 높은 만큼(13.7~14.8)
//   규칙이 요구량을 더 올리려 드는 상태다 — 밴드 안이므로 더 밀지 않는다.
// ── 【10-C 재적합】 물량이 2~5.9배가 되면서 조각도 그만큼 늘었다 ──────
//   구 값 그대로 두면 레벨업이 밤당 **14~47회**가 된다(목표 13.5). 4-4 밴드 12~15를
//   지키려면 요구량이 조각 총량과 같은 비율로 따라 올라야 한다.
//   **이것이 사장님이 말한 「몇 젬 = 레벨업」 재산정이다** — 지어낸 값이 아니라
//   실측 레벨업 횟수로 역산했다(신 = 구 × 실측Lv ÷ 13.5).
export const LEVEL_STEP_MEASURED = {
  N1: 200, N3: 260, N8: 510, N10: 490, N12: 480,
  N15: 480, N20: 770, N23: 800, N30: 1080,
};

// ── 실 플레이 레벨업 기준 — 모든 전투 밤 동일 ───────────────────
// 【사장님 확정 2026-08-12】 밤 2의 구 fallback base 30을 3배 한 90으로
// 밤 1~40 전투 밤 전체를 통일한다. `LEVEL_STEP_MEASURED`는 과거 계측과 명시적
// 프로브 주입값의 근거로 보존하며, 캠페인 실 플레이에서는 이 값 하나를 쓴다.
// 안식일은 전투·조각·레벨업이 없으므로 적용 대상이 아니다.
export const CAMPAIGN_LEVEL_BASE = 90;

// ── 【v2 처방 1】 조각당 레벨업 요구량 n을 「밤별 상수」에서 「밤 안의 곡선」으로 ──
//
// **문제**: n이 밤 안에서 상수인데 조각 유입률은 밤 안에서 11배 오른다. **분모가
// 상수인데 분자가 11배 오르면 레벨업은 반드시 후반에 몰린다.** 실측이 정확히 그
// 모양이었다 — 4분까지 1회, 뒤 8분에 10회. **VS와 정확히 반대다.**
//
//     n(u) = 그 시점의 조각 유입률 × (밤 길이 ÷ 목표 레벨업 수) × g(u)
//          = n_상수 × R(u)/R̄ × g(u)
//
// **자유 파라미터가 없다.** R(u)는 3막 밀도 곡선이 이미 갖고 있고, 밤 길이와 목표
// 레벨업 수는 확정값이다. g(u)만 새 값이며 **평균 1**이라야 한다.
//
// **경제가 정확히 보존된다** — 레벨업이 시간 균등이면 구간 i의 조각 획득
// = R_i × Δ = n_i 이므로 Σn_i = ∫R dt = 그 밤 총 조각이고 **레벨업 수도 정확히
// 13.5**다. 총액도 횟수도 안 움직이고 **분배만 바뀐다.** 불변식 ③ 무영향.
//
// **g(u)는 1로 둔다.** v2 8-1이 스스로 적었다 — *"g의 근거는 「VS가 그렇게 한다」뿐이다."*
// 근거 없는 계수를 넣지 않는다. **그리고 g ≡ 1로도 처방의 본체가 다 나온다** —
// 고치려던 것이 「분모가 상수」인 것 자체이기 때문이다. 앞당김을 더 원하면 그때 잰다.
// **분자는 「스폰 곡선」이 아니라 「지금 게이지가 차는 속도」다.**
//   처음엔 스폰 유입률 R(u)를 그대로 썼는데 실측에서 총 레벨업이 15.4 → 21로 샜다.
//   이유: **줍는 것이 떨구는 것보다 늦다.** 밤 끝의 소강 구간(R = 0.15)에서 요구량이
//   싸지는데 필드에는 직전 파도의 조각이 아직 깔려 있어, 싼 요구량으로 늦게 줍는
//   조각을 계속 환전한다. Σn = ∫R dt 라는 항등식이 **드랍과 회수가 동시일 때만**
//   성립하는데 이 게임은 그렇지 않다.
//   → 그래서 **실제 회수율의 최근 평균**을 쓴다. 그것이 정확히 "지금 게이지가 얼마나
//     빨리 차는가"이고, 회수 지연이 정의상 반영된다. 새 자유 파라미터는 창(window)
//     하나뿐이며 정규화 분모는 이미 아는 값(총 조각 ÷ 밤 길이)이다.
// ⚠⚠⚠ **폐기됐다 — `on: false`.**   【사장님 지시 2026-07-31】
//   *"다른 게임들처럼 초반에는 빠르게, 후반에는 느리게."*
//
//  이 장치는 요구량을 **지금 유입률에 비례**시켜 레벨업을 **시간 균등**으로 만든다.
//  그 목표가 사장님이 원하는 모양과 **정면으로 반대**다 — 균등은 「초반 빠름」이 아니다.
//  그리고 실측에서 균등조차 못 만들고 있었다:
//      첫 레벨업 **132~159초** · 마지막 1분에 **9~10회**(총 21~23회 중) · 끝 간격 0~4초
//  원인은 `cap: 2.5` 다. 마지막 구간에서 유입이 11배 뛰는데 요구량은 2.5배에서 잘리므로
//  **레벨업이 4.5배 빨라진다.** 자기보정을 하라고 넣은 상한이 자기보정을 푸는 자리였다.
//
//  **배선은 남긴다**(규율 5 — 되켤 수 있게). `on: false` 하나로 꺼진다.
//  되켜려면 `LEVEL_REQ.on` 을 끄고 이것을 켠다 — **둘이 동시에 켜지면 안 된다.**
export const LEVEL_CURVE = {
  on: false,               // ← 폐기. 아래 LEVEL_REQ 가 대신한다
  g: (_u) => 1,
  win: 20,
  floor: 0.35,
  cap: 2.5,
};

// ══════════════════════════════════════════════════════════════════
//  ■ 레벨업 요구량 — 10분 밤 실측 정본   【2026-08-17 재계측】
//
//      need(base, L) = round(base × first × growth^(L−1))
//
//  캠페인 전투 밤의 base는 모두 90이고, 채택값은 first=growth=1.25다.
//  따라서 실제 식은 need(L)=round(90 × 1.25^L), L은 현재 레벨(최소 1)이다.
//
//  ■ 근거
//    · 구 곡선(first 0.55 / growth 1.35)에서 시계 할인만 뺀 15회 누적은 12,611조각,
//      새 곡선은 12,341조각(−2.1%)이다. 밤 전체 성장 예산은 사실상 보존한다.
//    · 대신 첫 두 단계 누적은 117 → 254조각으로 옮긴다. N8 0치즈 입장의 Lv3
//      총수입이 2~3치즈에 머물던 문제를 6치즈로 고치면서 초반 연속 상점을 늦춘다.
//    · 5:00~5:30에 요구량을 1 → 0.08배로 깎던 시계 할인은 폐기한다. 조각 유입 자체가
//      스폰 파형을 이미 따르므로 시간 배수를 다시 얹으면 5분 레벨 폭발이 중복된다.
//    · N1·N2를 포함한 모든 캠페인 전투 밤은 같은 base와 이 함수 하나를 읽는다.
//
//  수식의 단일 정본은 levelRequirement()다. World와 검사는 식을 다시 쓰지 않는다.
// ══════════════════════════════════════════════════════════════════
export const LEVEL_REQ = Object.freeze({
  on: true,
  first: 1.25,
  growth: 1.25,
});

export function levelRequirement(base, level) {
  const b = Number.isFinite(base) ? Math.max(0, base) : 1;
  const L = Number.isFinite(level) ? Math.max(1, Math.floor(level)) : 1;
  return Math.max(1, Math.round(b * LEVEL_REQ.first * Math.pow(LEVEL_REQ.growth, L - 1)));
}
export const REQ_MODE = 'flat';
export const REQ_STEP = 0.375;                 // (B) 전용. 임의값 — 미검증
export const TARGET_LV = 13.5;                 // 4-4 "12~15"의 중점 = 산출기 levelTarget
export function reqShape(L) { return 1 + REQ_STEP * (L - 1); }
export function reqShapeSum(levels) {          // Σb(1 … levels), 소수 허용
  let s = 0; const k = Math.floor(levels);
  for (let L = 1; L <= k; L++) s += reqShape(L);
  return s + (levels - k) * reqShape(k + 1);
}
export function levelScaleFor(night) { return night.ledgerPieces / reqShapeSum(TARGET_LV); }
// 산출기 v2.0 levelStepOf — 밤별 상수 n
export function flatStep(night) {
  const p = night.ledgerPieces;
  if (p <= 0) return 0;
  return Math.max(10, 10 * Math.round(p / TARGET_LV / 10));
}
export function pieceReq(night, level, mode = REQ_MODE) {
  if (mode === 'flat') return Math.max(1, flatStep(night));
  return Math.max(1, Math.round(levelScaleFor(night) * reqShape(level)));
}

// ── 4-3 · 4-4 레벨업 상점 ───────────────────────────────────────
// 4-3 【확정】 **레벨업 1회 = 구매 최대 3회.** 하나만 사고 닫아도 된다.
//   리롤은 그 3회에 포함되지 않는다 — 제약은 횟수가 아니라 **가격**(회당 +1).
//   구 규칙 "구매 + 리롤 ≤ 3/턴"은 이것으로 대체·폐기.
// ■ **부품 가격은 장이 아니라 장착 결과 등급이 정한다.** 【2026-08-17】
//   캠페인 물량은 N1에서 하루 +0.25%만 오르는데 구 장별 정액
//   2/5/5/5/9/12는 그보다 훨씬 가파르게 올랐다. 그 결과 0치즈 N8은 Lv2(1치즈)·Lv3(2치즈)에
//   상점이 열려도 5치즈짜리 카드밖에 없어 두 세션이 통째로 죽었고, 후반 특수 밤은
//   수입이 줄어도 가격만 9·12로 올라 세트 추적까지 막혔다.
//   → 놓인 카드의 별이 아니라 **구매 뒤 실제 장착되는 별**을 아래 표에 넣는다.
//     같은 부품·같은 별 재구매가 5→◆를 만들면 ◆ 가격 12가 맞다.
//   낮은 별은 즉시 선택하게 하고, 원하는 조합을 더 찾는 비용은 3,4,5,… 리롤이 맡는다.
export const GEAR_PRICE_BY_TIER = Object.freeze([1, 2, 3, 5, 8, 12]);

export const SHOP = {
  priceByTier: GEAR_PRICE_BY_TIER,
  // 구 자동 전투 프로브가 넘기는 배율 인자를 깨지 않기 위한 무효 호환값이다.
  // 실제 부품 가격은 `gearPriceAt()` 하나만 읽는다.
  mult: 1.0,
  buysPerLevel: 3,     // 4-3 확정
  // ══════════════════════════════════════════════════════════════
  //  리롤은 정확히 **n번째 = base + (n-1)**. 즉 3,4,5,6,7,8,9,10…이다.
  //  UI·사람 상점·자동 구매·검산이 모두 아래 `rerollPriceAt` 하나를 사용한다.
  //  폐기한 배율과 반올림 루프는 SHOP에 남기지 않는다.
  // ══════════════════════════════════════════════════════════════
  rerollBase: 3, rerollPerNight: 2,
};
export function gearPriceAt(tier) {
  const t = Math.max(1, Math.min(GEAR_PRICE_BY_TIER.length,
    Math.floor(Number(tier) || 1)));
  return GEAR_PRICE_BY_TIER[t - 1];
}
// 구 자동 전투 프로브 호환 API. 그 경로에는 실제 제시 카드가 없으므로 중립 3성을
// 명시적 기본값으로 삼는다. 사람 상점은 이 함수를 우회하지 않고 `gearPriceAt`에
// 실제 장착 결과 등급을 넘긴다.
export function buyPrice(_i = 1, _mult = SHOP.mult, _nightNo = null, tier = 3) {
  return gearPriceAt(tier);
}
export function buyCum(n, _mult = SHOP.mult, tier = 3) {
  return Math.max(0, Math.floor(Number(n) || 0)) * gearPriceAt(tier);
}
export function rerollPriceAt(n) {          // n = 이번이 그 밤의 몇 번째 리롤인가(1-base)
  if (n <= 0) return 0;
  return SHOP.rerollBase + (Math.floor(n) - 1);
}
export function rerollCum(n) {
  let s = 0;
  for (let k = 1; k <= n; k++) s += rerollPriceAt(k);
  return s;
}

// ── 8-6a 무기 이펙트 = 강화 수치의 함수 ─────────────────────────
// "스탯 창 없이 내 빌드가 캐릭터에 그대로 보인다." 장식이 아니라 정보다(기둥 2).
//   물맷돌: 회전 속도 ← 연사 / 궤도 반경 ← 사거리 / 도는 돌 개수 ← 투사체 수
//   지팡이: 스윙 속도 ← 연사 / 호의 크기 ← 타격 반경
//
// ■ 빌드 3단계 — **전부 명세 정본 계산값이다. 임의값 없음.**
//   중첩 상한 5(명세 8장 카드 RNG 계약) · 축은 낮 3축 6단계 완주 기준.
//   파수 연사   = 1.5 × 1.1(축3 연사+10%) ÷ 0.9^중첩 (「골라둔 돌」 곱연산, 최소 간격 0.25초)
//   파수 투사체 = 1 + 중첩                            (「양손 던지기」 +1/중첩)
//   파수 사거리 = 13.5 × 1.1                          (축5 사거리+10%)
//   지팡이 스윙 = 0.8 × 1.1(축3 속도+10%) ÷ 0.9^중첩  (「손에 익은 자루」)
//   지팡이 반경 = 5 × 1.1(축5 반경+10%) × (1 + 0.15×중첩) (「긴 자루」 가산 중첩)
export const BUILD = {
  none:  { axis: 0, stack: 0, label: '무강화(구 회색박스 기본)' },
  mid:   { axis: 1, stack: 2, label: '평균 빌드(축6 + 요령 중첩 2 — 명세 8장 공급 검산 기준)' },
  max:   { axis: 1, stack: 5, label: '최대 빌드(축6 + 중첩 상한 5)' },
};

// ── 【10-B 6-2】 밤 안에서 자라는 빌드 — `ramp` ──────────────────
// **구 회색박스의 가장 큰 구멍**: 레벨업을 13~14회 세면서 그 레벨업이 무기에 아무
// 영향을 주지 않았다. world.autoWeapon 이 PASU.rate·BANG.rate 원값을 그대로 썼다.
// 즉 **한 번도 세지지 않는 플레이어**를 잰 것이고, 후반 밤이 전부 상한에 붙어
// 구분이 안 되던 것(10-A 미해결 ③ 「후반 3밤 뭉침」)의 직접 원인이 여기다.
//   실측: N30 무강화 처치 1,186 / 스폰 2,580 → **54%가 그냥 쌓인다.**
//   동시 개체 상한 점유 64%. 밤이 「포화」로 끝나니 어느 후반 밤이든 같아 보인다.
//
// ■ ramp 모델 — **레벨업 1회당 요령 중첩 +1, 상한 5.**
//   4-3이 레벨업 1회에 구매 3회를 주므로 한 갈래를 파는 플레이어는 레벨업마다
//   최소 한 번은 자기 카드를 집는다. 13~14 레벨업이면 5중첩은 밤의 앞 1/3에서 찬다.
//   **이것은 모델이지 측정값이 아니다** — 실제 분포는 카드 RNG·리롤에 달렸고,
//   그것을 재려면 8장 카드 풀이 확정돼야 한다(6-2 재설계 대기).
//   상한 5는 명세 8장 카드 RNG 계약이므로 임의값이 아니다.
// ■ 축(낮 3축)은 **밤 번호에 비례해 열린다.** 30밤에 걸쳐 6단계를 올리는 것이 3축의
//   설계이므로 밤 n에서 진척도 = n/30 으로 읽는다. 계단이 아니라 비례인 이유는
//   3축 노드가 밤 경계에 정렬돼 있지 않기 때문이다(낮에 아무 때나 찍는다).
// ── 【10-B 6-2】 카드 뽑기에서 유도한 중첩 누적률 ────────────────
// **처음에 나는 "레벨업 3택 1 풀이 보류 상태(빈 상자)"라고 진단했는데 그것이 틀렸다.**
// 명세 7장 336~344행에 풀이 **이미 확정돼 있다**: 무기 전용 5 + 공용 8 = **13종**,
// 무기 카드 **가중치 1.5배**, 등급 없음·올랜덤, 중첩 상한 5, 카드별 수치까지 전부.
// 보류인 것은 *"13종인가 18종인가"*(11장 미결 5) 하나뿐이다.
//   → 구멍은 **설계가 아니라 구현**이었다. 회색박스가 그 카드를 하나도 안 먹였다.
//
// ■ 중첩 누적률 — **레벨업 1회당 최대 1중첩이다.** 이걸 처음에 틀렸다.
//   8장 카드 RNG 계약이 *"3장 **서로 다름**"*이므로, 3장을 다 사도 **내 카드는 그중
//   많아야 한 장**이다. 구매 횟수에 비례한다고 모델링하면(첫 구현) 3배로 부푼다.
//     총 가중치 = 무기 5장 × 1.5 + 공용 8장 × 1 = **15.5**
//     무기 카드 1종이 3택에 뜰 확률 = 1 − (1 − 1.5/15.5)³ = **0.2634/레벨업**
//   레벨업 13.5회면 **3.56중첩** — 상한 5에 닿지 않는다. 한 갈래만 파는 플레이어의
//   기대치이며, "카드가 떴을 때만 집는다"가 곧 3택 1의 문법이다.
//   (구 모델 0.75/레벨업은 레벨 7에서 상한을 쳐서 밤의 2/3을 만렙으로 보냈고,
//    그래서 N1 원딜이 안정성 99.7 · 피해 0 — 밤이 통째로 사라졌다.)
//
// 【2026-07-31】 카드 상수(CARD)·중첩 모델(stacksFromPicks)·구 무기 스탯(weaponStats)이
//   여기 있었다 — **카드 체계 삭제**(지팡이 삭제와 함께). 물맷돌 스탯은 `mods.gearWeaponStats` 가 정본이다.
// ⚠ 분모는 **여정 길이**다. 30 이 손으로 박혀 있었고 40일 개편에서 갈아 끼웠다
//   — 안 고쳤으면 30일째에 축이 100% 로 차고 남은 10일이 평평해졌을 것이다.
export function axisProgressFor(nightNo) {
  return Math.min(1, Math.max(0, (nightNo ?? 1) / CAMPAIGN_DAYS));
}

// ■ 이펙트 함수의 형태 — **⑦의 결론.**
//   전 채널을 한 형태로 통일한다:  f(x) = cap × tanh(x / cap)
//     · x ≪ cap 이면 f ≈ x  → 초반 강화 한 단계가 눈에 그대로 보인다(정보 채널로 정확)
//     · x → ∞  이면 f → cap → 후반 누적에서 잔상으로 무너지지 않는다
//     · 단조 증가·미분 연속이라 "강화했는데 이펙트가 안 변한다"는 구간이 없다
//   구간 상한(clamp)이 아니라 tanh인 이유: clamp는 상한 도달 후 **정확히 멈춰서**
//   그 뒤 강화가 화면에서 사라진다. tanh는 계속 조금씩 움직여 "더 세졌다"가 남는다.
//   로그가 아닌 이유: log는 0 근처에서 발산해 무강화 기준값을 정의할 수 없다.
export function soft(x, cap) { return cap * Math.tanh(x / cap); }

// **잔상 문턱 (spinCap의 유일한 물리 근거)**
//   프레임당 이동 거리가 자기 몸 지름을 넘으면 연속된 두 프레임의 상이 겹치지 않아
//   개별 돌이 아니라 궤적(잔상)으로 읽힌다. 60Hz 기준 v_read = 돌 지름 × 60.
//   돌 반지름은 투사체 렌더값 2.6px을 그대로 쓴다 — **도는 돌과 날아가는 돌은 같은 물건이다.**
export const STONE_R = 2.6;
export const FPS_REF = 60;
export function spinCap(orbitR) { return (STONE_R * 2 * FPS_REF) / Math.max(orbitR, 1); }  // rad/초

// ■ 채널별 규약 — **크기 채널과 속도 채널을 다르게 다룬다.**
//   · 지팡이 호 반경 = **실제 타격 반경과 1:1.** 압축 금지. 이건 지표가 아니라 판정 그 자체다.
//   · 물맷돌 궤도 반경 = 사거리의 **지표**일 뿐(실제 사거리 13.5유닛을 그릴 수는 없다) → 압축 가능.
//   · 속도 채널(회전·스윙) = 전부 압축. 정확한 수치는 어차피 눈으로 못 세고, 문제는 잔상이다.
//   ORBIT_BASE / ORBIT_CAP / SPIN_REV_PER_SHOT 셋은 **시각 판정값이다(⑦).** 근거는 gb.html 육안 확인.
// ── 【사장님 결정 2026-07-28】 무릿매는 **지표가 아니라 물건**이다 ──────
//   구 구현은 사거리·연사·투사체 수를 **궤도 원의 반경·속도·점 개수**로 그렸다.
//   화면에는 플레이어 위로 큰 원이 하나 뜨고 그 위를 점이 돌았다 — 실측 소감:
//   *"인위적이다. 진짜 물멧돌 돌아가게 만들어."*
//   → **원을 걷어낸다.** 무릿매는 손 옆에서 **짧고 빠르게** 돌고, 강화는
//     **날아가는 돌 쪽에서** 읽는다(사장님 지시).
//
//   ■ 이것이 8-6a 의 채널 하나를 **폐기한다**: 「도는 돌 개수 ← 투사체 수」.
//     대신 그 정보는 **부채꼴로 나가는 발의 수**가 그대로 들고 있다 — 지표를
//     보는 대신 실물을 본다. 사거리도 마찬가지다(원 반경 대신 **날아간 거리**).
//     v2 D4 「모든 카드는 세는 채널을 하나 이상 갖는다」는 유지된다: 세는 자리가
//     궤도에서 탄도로 옮겨 갔을 뿐이다.
//   ■ 회전 속도는 **고정**한다. 연사에 안 걸린다 — 강화가 궤도에 안 실리므로
//     속도를 바꿀 이유가 없고, 사장님 지시가 *"처음부터 빠르게, 잔상 보이게 고정"*이다.
// Equipment feedback is shared by the shop card, combat scene and screen VFX.
// Keep its timing and ring geometry in one place so all three surfaces finish
// the same purchase beat together.
export const EQUIP_FX = Object.freeze({ sec: 0.78, ring: 4, spread: 18 });

export const SLING = {
  R: 0.864 * UNIT,       // 손 옆 회전 반경 (구 0.72 × 1.2 — 사장님 지시)
  SPIN: 15.5,            // rad/초 ≈ 2.5회전/초. **잔상 문턱 위**
  GHOSTS: 7,             // 잔상 개수 — 픽셀아트에서 흐림은 유령 복사로 낸다
  GHOST_ARC: 2.6,        // 유령이 덮는 각(rad ≈ 149°). 이 각이 곧 「얼마나 빨라 보이나」
  // ── 회전 중심 = **방향·걷기 프레임별 든손 소켓** ─────────────
  //   8방향 시트의 손 위치가 서로 다르므로 고정 HAND_X/Y 는 폐기했다.
  //   scene.SLING_HAND_SOCKET 이 32프레임의 검지·엄지 자리를 직접 들고 있고,
  //   origin (0.5, 0.9375) → 앵커 픽셀 (32, 60)을 기준으로 월드 좌표에 붙인다.
  // ── 줄 ──────────────────────────────────────────────────────
  //   **밝고 두꺼운 줄을 그리면 칼이 된다.** 처음 구현이 그랬다 — 굵은 선 하나가
  //   빠르게 도니 화면에서 검을 휘두르는 것으로 읽혔다. 무릿매의 줄은 가늘고
  //   어둡다. 보이는 것은 줄이 아니라 **끝의 돌**이어야 한다.
  CORD_FROM: 0.62,       // 줄이 시작되는 지점(손에서 돌 쪽으로). **돌 뒤의 짧은 토막만**
                         //   보인다 — 손까지 이으면 그 선이 곧 칼날로 읽힌다(실측 소감)
  CORD_W: 0.9,           // 줄 두께(px 기준) — 얇다
  CORD_A: 0.30,          // 줄 투명도 — 어둡다
};

// ── 회전 광역 「도는 돌이 친다」 【사장님 결정 2026-07-29】 ─────────
// **몸 옆에서 도는 물맷돌 자체가 판정을 갖는다.** 그림은 이미 있었고 판정만 없었다.
//
// 왜 필요했나 — 실측: 무강화 물맷돌 `1.5발/초 × 1발 = 1.5킬/초`, N8 스폰 12.6마리/초.
// **1:1 무기로는 구조적으로 못 이긴다.** 광역을 놓을 자리가 셋인데(내 주변 / 날아가는 중 /
// 맞은 자리) **「내 주변」이 통째로 비어 있었다** — 뱀서라이크가 물량을 지우는 바로 그 자리다.
//
// 왜 이 방식인가:
//   · **새로 그릴 게 없다** — scene.drawSling() 이 이미 돌·끈을 그린다
//   · **물리적으로 맞다** — 물맷돌을 돌리고 있으면 짐승이 가까이 못 온다. 폭발도 마법도 아니다
//   · **기존 부품 축이 그대로 걸린다** — 반경←끈(사거리와 같은 물리값) 주기←걸이 피해←돌
//   · **밀집도 정체성과 정합** — 붐벼야 맞는다(불가침 3의 연장)
//   · **지팡이와 안 겹친다** — 지팡이 호는 5유닛, 이건 0.864유닛(몸 바로 옆)
//   · **위험 보상** — 맞히려면 붙어야 하고, 붙으면 안정성이 깎이고 몹 피해(×10)를 받는다
//
// **넉백 없다**(사장님 지시). 밀어내면 자기 판정을 스스로 비운다.
// ── 타격감 【사장님 지시 2026-07-29 "SSS급으로"】 ─────────────────
// **한 대 때릴 때마다 화면이 반응하는 것** — SSS급 뱀서라이크의 정체는 이펙트
// 개수가 아니라 이것이다. 우리는 통째로 비어 있었다.
//   · 히트스톱  — 큰 타격에 시간이 아주 잠깐 느려진다. **타격감의 8할**
//   · 흔들림    — 착탄 광역·회전 타격에도. 세기는 규모에 비례
//   · 튀어나감  — 적이 그냥 사라지지 않고 **맞은 방향으로 밀려나며** 스러진다
//   · 연쇄      — 짧은 시간에 여러 마리가 죽으면 **한 덩어리로 크게** 번쩍
// ⚠ **완전 정지가 아니라 감속이다.** 프레임을 멈추면 입력이 씹혀서
//   「이동 하나」(불가침 1)가 그 순간 끊긴다.
export const HIT = {
  slow: 0.18,        // 히트스톱 동안의 시간 배율
  land: 0.075,       // 착탄 광역
  orbit: 0.05,       // 회전 타격(2체 이상)
  elite: 0.09,       // 정예·위협 처치
  max: 0.14,         // 한 번에 쌓일 수 있는 상한 — 길면 게임이 끊긴다
  fly: 190,          // 처치 시 튀어나가는 속도(px/초)
  flyDrag: 4.2,      // 그 감속
  comboWin: 0.12,    // 이 안에 죽은 것들을 **한 덩어리**로 센다
};

// ── 부품이 ORBIT 에 닿는 세 자리 【D. 걸이 축 이동 — 명중 → 궤도】 ──────
// **여기 상수는 「몸 옆에서 도는 물맷돌」의 뼈대이고, 부품은 그 위에 배율로 얹힌다.**
// 어느 부위가 어느 상수를 미는지 한 곳에 적어 둔다 — 셋이 서로 다른 부위에서 온다:
//
//   ORBIT.r      × mods.orbitR      ← **끈**  (사거리와 같은 물리값. 길수록 크게 돈다)
//   ORBIT.tick   ÷ mods.orbitRate   ← **돌 + 걸이** (가벼운 돌·빨리 돌리는 걸이 = 자주)
//   ORBIT.dmgRatio × mods.orbitDmg  ← **돌 + 걸이의 `orbit`**  ⚠ 구 걸이 `aim` 자리다
//   ORBIT.cap    — 부품이 안 건드린다. **300마리 화면에서의 난간**이지 축이 아니다
//
// ⚠ **묵은 걸이가 궤도를 제일 세게 민다**(orbit 1.40 · 여섯 중 최고). 차돌은 던지면
//   필드에 남으므로 회수 왕복 동안 손이 빈다 — **그 공백을 메우는 것이 궤도**이고,
//   그래서 묵은 걸이만 연사가 제일 낮고(0.80) 궤도가 제일 높다. 한 벌이다.
export const ORBIT = {
  // ⚠ **판정 반경은 그림(SLING.R = 0.864유닛)과 분리한다.**
  //   그림은 사장님 지시대로 「손 옆에서 짧고 빠르게」 유지하고, 판정은 그보다 넓다.
  //   실측: 판정을 접촉 거리(0.86유닛)에 묶으면 붙은 적만 맞아 ×1.3에 그친다.
  //   → **넓힌 만큼은 「칠 때 퍼지는 링」으로 화면이 말한다**(scene.drawOrbitRing).
  r: 2.2 * UNIT,
  pad: 0,
  // ⚠ **머리 위로 돌리는 타원이다**(사장님 지시 2026-07-29).
  //   실제 물맷돌은 머리 위에서 돈다. 탑다운 60도에서 그 원은 **세로가 짧게** 보인다
  //   — cos 60° ≈ 0.5. 그림만 타원으로 하면 판정과 어긋나므로 **판정도 같은 타원**이다.
  ky: 0.55,
  // 중심은 **엄지와 검지 사이**(SLING.HAND_X/Y)이고, 머리 위로 조금 더 올린다.
  cy: -0.34 * UNIT,
  // **주기는 초당 고정이다** — 회전 속도는 시각 채널(SLING.SPIN 고정)이라 판정과 분리해야
  // 예측이 된다. 「몇 바퀴에 한 번」으로 묶으면 그림을 바꿀 때마다 밸런스가 흔들린다.
  tick: 0.40,
  // 한 번에 몇 마리. **상한이 없으면 300마리 화면에서 폭주한다.**
  cap: 4,
  // 발당 피해의 몇 할. 던지는 것보다 세면 던질 이유가 없다.
  dmgRatio: 0.55,
  // ⚠⚠ **두 겹이다**(사장님 지시 2026-07-30 3차 — 차돌 「광역기」).
  //   *"그 물멧돌 범위 안에 있는 모두가 맞는거고, 돌업그레이드 도는 궤적중 **돌에
  //   해당하는 부분** 히트박스가 더 커지고 데미지 증가"*
  //     · 원 **안 전체** → 기본 피해 × 이 비율        (끈이 만드는 범위. 광역)
  //     · 돌이 지나가는 **대역**(|r − R| ≤ band × R) → 기본 피해 전량 (돌이 두께를 민다)
  //   `mods.orbitBand === 0`(차돌이 아닌 다섯)이면 대역이 없고 **원 전체가 전량**이다 —
  //   즉 다른 돌의 궤도 판정은 **한 줄도 안 바뀐다.**
  // 차돌 고등급에서 넓은 원 안쪽까지 물량층을 한 틱에 지우던 문턱을 끊는다.
  // 바깥 강타 대역은 전량 피해를 유지해 위치를 맞추는 보상은 그대로다.
  discRatio: 0.30,
  // 상시 근접 틱은 흔들림·링만 남기고 전역 시간을 늦추지 않는다. 구 hitstop은
  // T5 풀세트 240실초 중 world clock을 약 18초 늦춰 숨은 방어력으로 작동했다.
  meleeHitstop: 0,
};

// ══════════════════════════════════════════════════════════════════
//  ■■ 돌 셋의 **판정 상수** — 값이 아니라 「어떻게 도는가」  【2026-07-30】
//
//  ⚠⚠ **크기를 정하는 값은 여기 없다.** 등급·부품이 정하는 값(튐 횟수·첫 간격·
//    등비·성장 폭·식는 시간)은 전부 `gear.js` 의 `STONE_AXIS`/`SKIP`/`GROW` 한 곳에
//    있다. 두 파일에 같은 값을 적으면 **한쪽만 고쳐지는 사고**가 난다 — 이 저장소의
//    상습 결함이다. 여기 있는 것은 **월드가 그 값을 굴리는 데 필요한 것**뿐이다.
// ══════════════════════════════════════════════════════════════════

// ── 물수제비(거친 납작한 돌)를 굴리는 데 필요한 것 ────────────────
// **튐은 텔레포트가 아니라 비행이다.** 착탄하면 투사체가 사라지지 않고 제 속도로
// 계속 날아가되, **다음 간격만큼 나아가기 전에는 아무것도 못 친다**(= 물 위를 미끄러지는
// 구간). 그래서 자국이 화면 좌표에서 반드시 앞으로 간다 — *제자리에서 25번 튀지 않는다.*
//   ⚠ 「빠르다」는 새 상수로 만드는 것이 아니다. 간격이 등비로 줄면 시간도 같이 준다.
export const SKIPW = {
  // 남은 간격을 날아갈 만큼은 살려 준다. 안 그러면 최종 사거리에서 뒤쪽 튐이 잘린다
  // (거친 세트는 감쇠가 1이라 총 이동이 사거리의 5배까지 간다).
  lifePad: 0.10,        // ⚠【잠정】 여유(초)
  maxLife: 4.0,         // ⚠【잠정】 그래도 이보다 오래는 안 산다 — 화면에 유령이 남는다
  // 필드 밖으로 나간 튐 돌은 바로 치운다. 적은 필드 안에만 있으므로 밖의 돌은
  // 아무 일도 안 하면서 목록만 차지한다(동시 투사체 수 = 프레임 예산이다).
  outMargin: 6 * UNIT,  // ⚠【잠정】
};

// ⚠ 구 `KEEP` — **삭제됐다**(묵은 차돌 — 바닥에 떨어진 돌이 굴러 멎는 감속).
//   차돌이 근접(궤도)으로 재설계되어 바닥에 남는 돌이 없다(2026-07-30).

// ── 세트 효과가 쓰는 판정 상수 ────────────────────────────────────
// ⚠ **크기(몇 번·몇 배)는 gear.js 가 정한다.** 여기 있는 것은 「언제」뿐이다.
export const SETFX = {
  againSec: 0.32,       // ⚠【잠정】 굳은 세트 — 터진 자리가 **또** 터지기까지의 간격(초)
  // ── 표시 — **색을 쓰지 않는다**(충돌 6). `TIER_COLOR` 5색이 이미 등급을 말한다 ──
  //   쓰는 채널은 **방향과 겹**이다: 궤도 바깥에 **거꾸로 도는 토막 링**이 한 겹 더 생긴다.
  //   등급 색 그대로 그리되 「반대로 돈다」는 것 자체가 신호다 — 색 채널을 안 건드린다.
  ringSegs: 9,          // ⚠【잠정】 토막 개수(작게). 크게는 두 배
  ringSpin: -2.1,       // ⚠【잠정】 rad/초. **음수 = 돌과 반대 방향**이 이 표시의 정체다
  ringGap: 1.30,        // ⚠【잠정】 궤도 타원 대비 반경 배수 — 바깥에 있어야 안 가린다
};

// ══════════════════════════════════════════════════════════════════
//  ■■ 돌 셋의 **그림 상수** — 판정이 아니다. scene 만 읽는다  【2026-07-30】
//    ⚠ 여기 값은 **하나도 판정에 안 들어간다.** 그런데도 이 재설계에서 제일 중요한
//      자리다 — 진단이 *"화면에 안 보이는 셋이 애매하다"* 였고, 원인이
//      「등급이 시각 채널을 하나도 안 건드린 것」이었다.
// ══════════════════════════════════════════════════════════════════

// ── 성긴 고른 돌 「선」 — 날아가는 돌 뒤로 **돌을 더 놓는다** ────────
// ⚠⚠ **빛나는 선이 아니라 돌이 촘촘한 선이다**(A-1). 트레일을 밝히면 판타지가 된다.
//   그래서 `gear.lineGap`(1 = 평범 · 0 = 붙는다)을 **간격**으로 읽어 같은 돌 스프라이트를
//   뒤로 깔기만 한다. ●●●●● 에서 간격이 0.39 로 좁아지고, 성긴 세트가 뜨면 0 이 되어
//   **돌들이 서로 닿아 끊긴 선 하나가 화면을 가른다.**
// ⚠ 연사 하드 상한(4발/초)이 실제 발 간격을 4.8유닛에 묶어 두므로(직전 단계 ⓒ)
//   「촘촘한 선」은 판정으로는 만들 수 없다. **이 그림이 그 축의 유일한 출구다.**
// ⚠⚠ **길이는 고정, 촘촘함만 등급을 탄다.** 처음엔 개수를 고정하고 간격만 좁혔는데
//   그러면 **등급이 오를수록 자취가 짧아져** *"화면을 가른다"* 의 반대가 된다.
//   → 자취 **길이**를 고정하고, `lineGap` 은 **한 칸이 돌 지름의 몇 배인가**를 정한다
//     (아래 실측 정정 참조 — 「몇 개로 채우는가」가 아니다).
// ⚠ `span` 은 지어낸 값이 아니라 **역산**이다: 성긴 세트 ●●●●● 의 실측 연사가 4.83발/초
//   이고 투사체 속도가 620px/초이므로 **연달아 나가는 두 발 사이가 620 ÷ 4.83 = 128px
//   = 4유닛**이다(UNIT = 32). 자취가 그 길이면 **앞 발의 꼬리가 다음 발의 머리에 닿는다** —
//   그때 비로소 플레이어에서 최종 사거리 끝까지 돌이 이어진다. 그것이 A-1 의 문장이다.
// ⚠ **`step`·`touch` 도 지어낸 값이 아니다 — 이 저장소가 이미 갖고 있던 문턱에서 왔다.**
//   `maxStones()` 주석: *"이웃 간 간격 ≥ 돌 지름 1개"*, `scene` HUD:
//   *"간격 ≤ 돌 지름 → 개별 돌로 읽힘 / 넘으면 잔상"*. 그 문턱에 맞춰 두 끝을 잡았다
//   (한 칸을 **돌 지름 배수**로 환산한 실측):
//     ●○○○○ 1.16 지름 → **개별 돌**  = *"●○○○○ 는 평범"*
//     ●●●○○ 1.01 지름 → 경계
//     ●●●●● 0.70 지름 → **잔상(선)** = *"돌이 촘촘해 끊긴 선"*
//     ●●●●● + 성긴 세트 0.34 지름 → **완전히 붙는다** = *"간격이 사라진다"*
// ⚠⚠ **「개수만 는다」는 화면에서 성립하지 않는다.**   【실측 2026-07-30 — 문구 정정】
//   `drawLineStones` 를 스텁 위에서 돌려 실제로 그려진 스프라이트를 셌더니 세트를 깬
//   상태에서 ●1 12알 · ●2 11 · ●3 11 · ●4 11 · ●5 12알로 **개수가 평평**했다.
//   길이는 123~134px(목표 128)로 고정되니 그쪽은 맞다. 개수가 안 느는 이유는
//   한 칸이 `D = 12 × artScale × stoneSize` 에 걸려 있고 **`stoneSize` 가 등급마다
//   +13% 커져**(0.80 → 1.22) `lineGap` 축소(0.891 → 0.394)를 상쇄하기 때문이다.
//   → 실제로 움직이는 채널은 **한 칸 ÷ 돌 지름 비**다(1.16 → 1.09 → 1.01 → 0.87 → 0.70).
//     그 비가 1 을 밑돌면 **돌이 서로 겹쳐** 이 저장소가 이미 적어 둔 문턱
//     (*"간격 ≤ 돌 지름 → 개별 돌 / 넘으면 잔상"*)을 넘어간다 — 설계 의도는 화면에서
//     성립하고 **문구만 틀렸다.** 개수가 실제로 뛰는 것은 세트뿐이다(●●●●○ 16 · ●●●●● 26).
export const LINEV = {
  span: 4.0 * UNIT,     // 자취 길이(px) — **위 역산값**(= 128px). 등급과 무관하게 고정
  nMax: 32,             // 한 발이 깔 수 있는 최대 개수 — **발 하나의 난간**(총량이 아니다)
  // ⚠ **총량 난간은 따로 있어야 한다.**   【검증 2026-07-30】
  //   `nMax` 는 발 하나만 자르고 `drawLineStones` 는 **발마다** 그만큼 더 깐다 —
  //   총량은 발 수 × N 이므로 `nMax` 는 **총량을 한 톨도 안 막는다.** 게다가 실측 N 이
  //   8~20 이라 `nMax 32` 자체가 **한 번도 안 걸린다** = 엉뚱한 축을 막는 난간이었다.
  //   → 자취를 받는 **발의 수**를 자른다. 값은 지어내지 않았다: `drawTrailBatch` 의
  //     `maxTrails 14` 와 **같은 수**다. 이 저장소가 이미 「자취 14개까지는 프레임에
  //     얹어도 된다」고 정해 둔 자리(궤도 자취 하나가 18표본 × 3패스)와 나란히 둔다.
  //   ⚠ **지금은 아슬하게 안 문다** — 실측(N8·N30 · 고른 돌 ●5 성긴 세트 · 4분):
  //       부가 줄 없음  동시 본체 발 10 → 자취 200개
  //       굴림 + 튐     동시 본체 발 **14** → 자취 **280개**  ← 난간이 정확히 이 자리다
  //     즉 총량 최악이 280 이고 난간이 14 라 지금은 통과한다. 그래도 두는 이유:
  //     **발 수 상한이 한 칸만 올라도 총량이 그대로 곱해진다.** 자취를 받는 돌은
  //     `pierceInf` 인 고른 돌뿐이고 그 돌은 발 1 이라 지금 14 에 머무는 것이며,
  //     그 전제가 바뀌는 날 이 값이 없으면 조용히 수백 장이 더 깔린다.
  //   ⚠ 프레임 시간은 **못 쟀다** — 헤드리스에 렌더러가 없다. 【렌더 실측 대기】
  maxLines: 14,         // 자취를 받는 발의 최대 수 — 넘는 발은 자취 없이 본체만 난다
  step: 0.92,           // 한 칸 = 돌 지름 × (touch + step × lineGap). 위 문턱에서 잡았다
  touch: 0.34,          // lineGap 0 일 때의 한 칸 — 서로 닿되 한 덩어리는 아니다
  fade: 0.62,           // ⚠【잠정】 뒤로 갈수록 옅어지는 비율(끝 돌의 투명도)
  shrink: 0.30,         // ⚠【잠정】 뒤로 갈수록 작아지는 비율(끝 돌의 크기 감소분)

  // ══════════════════════════════════════════════════════════════
  //  「진짜 선」 — **돌 사이를 실이 잇는다**   【사장님 지시 2026-08-02】
  //    *"고른 돌 이펙트 진짜 레이저같은 연출로. 과한 레이저 말고,
  //      지금은 뭔가 좀 다른 돌에 비해서 삼삼해."*
  //
  //  ⚠ **이 파일이 원래 「트레일을 밝히지 않는다」고 적어 두었다**
  //    (*"빛나면 판타지고 돌이 빽빽하면 고증이다"*). 사장님 지시로 **뒤집는다.**
  //    다만 **빛으로 안 뒤집는다** — 「과한 레이저 말고」가 같이 온 지시다.
  //    레이저로 읽히게 하는 것은 밝기가 아니라 **이어짐**이다:
  //      ⓐ 돌과 돌 **사이를 실이 채운다**(간격이 사라진다 = 세트 문구 그대로)
  //      ⓑ 돌이 **날아가는 쪽으로 눕고 늘어난다**(회전을 멈춘다 — 잔상이 된다)
  //    돌은 그대로 보인다. 실은 **돌 뒤(depth 29)** 에 깔려 틈만 메운다.
  //
  //  ■ **세기는 새 축이 아니다.** 이 저장소가 이미 쓰는 채널
  //    「한 칸 ÷ 돌 지름」을 그대로 읽는다(위 900행). 실측:
  //        ●1 1.16 · ●2 1.09 · ●3 1.01 · ●4 0.61 · ●5(성긴 세트) 0.34
  //    1 을 밑돌면 돌이 겹치기 시작한다 — 실도 거기서부터 뚜렷해진다.
  //  ■ 양 끝은 **유도값이다. 지어낸 수가 아니다:**
  //        ratioOpen  = touch + step × gapBase(●1) = 0.34 + 0.92 × 0.891 = 1.16
  //        ratioShut  = touch                      = 0.34   (lineGap 0 = 성긴 세트)
  // ══════════════════════════════════════════════════════════════
  core: {
    // ⚠⚠ **등급은 세기를 밀 뿐, 있고 없고를 가르지 않는다** 【사장님 지시 2026-08-02】
    //   *"고른돌 1단계부터 이펙트가 나와야지. 그래야 사람들이 아 이것도 좋구나 하지."*
    //   첫 판은 ●1 에서 선 세기가 **정확히 0** 이었다 — 즉 ●1 고른 돌이 다른 돌과
    //   화면에서 **구별이 안 됐다.** 그러면 「이 돌을 왜 고르나」가 안 보이고,
    //   좋은 줄 모르는 물건은 안 팔린다. **성격은 처음부터, 등급은 그 위에.**
    //   → 아래 `base` 만큼을 바닥으로 깔고 나머지를 등급이 채운다.
    //   ⚠ 이 바닥은 **고른 돌에만** 깔린다(`pierceInf` 가 아니면 `lineness` 가 0 을
    //     그 자리에서 돌려준다). 다른 다섯 돌은 한 톨도 안 바뀐다.
    base: 0.40,         // ⚠【잠정】 ●1 에서도 이만큼은 이어져 있다
    ratioOpen: 1.16,    // 등급이 미는 구간의 시작(●1 의 한 칸÷지름)
    ratioShut: 0.34,    // 여기서 **완전히 이어진다**(성긴 세트)
    wMin: 0.9,          // ⚠【잠정】 실 두께(px × artScale) — ●1 언저리
    wMax: 3.0,          // ⚠【잠정】 실 두께 — 세트 완성
    aMin: 0.20,         // ⚠【잠정】 실 투명도 — 거의 안 보인다
    aMax: 0.70,         // ⚠【잠정】 실 투명도 — 뚜렷하되 돌을 안 지운다
    filamentW: 0.28,    // 기존 색선 중앙의 얇은 밝은 심선 — 레이저 판독성만 조금 보탠다
    filamentMin: 0.55,  // 저등급에서도 한 픽셀 안팎으로 심선이 끊기지 않게 하는 하한
    filamentAMin: 0.14, // 돌 질감을 덮지 않는 낮은 등급 심선 투명도
    filamentAMax: 0.32, // 완성 세트에서도 광선처럼 과해지지 않는 상한
    stretch: 0.95,      // ⚠【잠정】 돌이 날아가는 쪽으로 늘어나는 몫(세트에서 최대)
  },
};

// ── 거친 납작한 돌 「물수제비」 — **자국이 앞으로 줄줄이** ──────────
// ⚠⚠ 이 돌만 **시각 채널이 하나도 없었다.** 자국은 광역이 금지돼 있어(gear.SKIP)
//   `explodeAt` 을 안 타므로 `decals` 에 한 톨도 안 남았고, 예산 25 가 화면에서 통째로
//   안 보였다 — 진단이 지목한 *"화면에 안 보이는 셋"* 이 여기서 안 닫혀 있었다.
// ⚠ **값이 아니라 문턱을 쓴다 — 하나도 지어내지 않았다:**
//   · `cap 90`  = `BLOOD.cap`(이 저장소의 제일 큰 지면 자국 예산)과 **같은 수**.
//                 얼룩은 하나에 원 6개(얼룩+방울 5)이고 자국은 **원 하나**이므로
//                 같은 수를 써도 프레임 비용은 얼룩의 1/6 이다.
//                 실측 자국 생성률이 초당 ~100개라 **상한이 곧 「최근 4발분」**이 되는데,
//                 그것이 정확히 「줄줄이」로 읽히는 길이다(한 발의 자국이 23개).
//   · `life`    = `SKIPW.maxLife`(4.0초). **그 발이 살 수 있던 시간만큼 자국이 남는다** —
//                 새 수명 개념을 만들지 않는다.
//   · `hop`     = 돌 지름(12px, 스프라이트에서 잰 값)보다 **작게**. 떠오르는 것이
//                 보이되 날아가는 것과 안 헷갈릴 만큼만.
export const SKIPV = {
  cap: 90,              // 링버퍼 상한 — `BLOOD.cap` 과 같은 수(위 근거)
  life: 4.0,            // 자국 수명(초) = `SKIPW.maxLife`
  r: 4.5,               // ⚠【잠정】 자국 반경(px) — 돌 지름의 3/4
  hop: 9,               // ⚠【잠정】 튐 사이에 떠오르는 높이(px). 돌 지름 12 보다 작다
  ringSec: 0.20,        // ⚠【잠정】 자국이 난 순간 톡 퍼지는 고리의 수명(초)
};

// ⚠ 구 `KEEPV` — **삭제됐다**(묵은 차돌 — 바닥에 남은 돌의 그림).
//   차돌이 근접(궤도)으로 재설계되어 바닥에 남는 돌이 없다(2026-07-30).

export const EFFECT = {
  ORBIT_BASE: 1.5 * UNIT,     // (구) 궤도 반경 — **무릿매 렌더에서 폐기.** HUD 계측에만 남는다
  ORBIT_CAP:  3.2 * UNIT,     // (구) 점근 상한 — 같음
  // **⑦ 실측으로 정한 값. 원래 후보는 1.0(한 발 = 한 바퀴)이었고 그것은 틀렸다.**
  //   1.0에서는 **무강화에서 이미** 프레임당 7.5px 이동(돌 지름 5.2px의 1.45배)이라
  //   점근을 걸기 전에 이미 잔상이다. 8-6a는 "후반 누적에서 무너진다"고 했지만
  //   실측은 처음부터 무너져 있었다.
  //   최대 빌드(연사 2.794발/초 · 궤도 1.65유닛)에서 프레임당 이동 ≤ 돌 지름을 풀면
  //   기울기 ≤ 0.337 → **1/3**을 쓴다. 그러면 무강화 0.50 → 최대 0.93 회전/초로
  //   1.86배의 가시 범위가 생기고 전 구간이 잔상 문턱 안에 남는다.
  SPIN_REV_PER_SHOT: 1 / 3,
  SWING_ANIM: 0.18,           // 스윙 호가 떠 있는 시간(초). 연사가 올라가면 아래 식이 줄인다
};
// 궤도 반경 ← 사거리. 기준 사거리에서 ORBIT_BASE, 늘어나면 ORBIT_CAP으로 수렴.
export function orbitRadius(range) {
  return soft(EFFECT.ORBIT_BASE * (range / PASU.range), EFFECT.ORBIT_CAP);
}
// 회전 각속도 ← 연사. 선형값(한 발 = 한 바퀴)을 잔상 문턱으로 눌러 준다.
export function spinRate(rate, orbitR) {
  return soft(2 * Math.PI * rate * EFFECT.SPIN_REV_PER_SHOT, spinCap(orbitR));
}
// 【2026-07-31】 swingAnim(지팡이 스윙 길이)이 여기 있었다 — 무기 삭제.
// 돌 개수 ← 투사체 수 (1:1, 정수). 다만 궤도 둘레가 좁으면 돌끼리 붙는다:
//   이웃 간 간격 ≥ 돌 지름 1개  ⇔  2πR/k ≥ 2×(2·STONE_R)  ⇔  k ≤ πR/(2·STONE_R)
export function maxStones(orbitR) { return Math.floor(Math.PI * orbitR / (2 * STONE_R)); }

// ── 5-9 기도 ──────────────────────────────────────────────────────
// ⚠ **`prayerMult(retries)` 가 여기 있었다** 【재시도 삭제 2026-08-03】.
//   재시도마다 그 밤 물량을 15% 깎던 「기도」다. 재시도가 사라져 부를 곳이 없다.
//   ⚠ **반쯤 살려 두지 않는다** — 이 저장소는 「폐기됐는데 왜 도나」를 이미 여러 번
//     겪었다(도둑·피로·해질녘). 되살릴 때는 이 주석과 git 이력이 설계를 들고 있다.
//   기도는 사라진 게 아니라 **실패한 다음 날 아침의 연출**이 됐다(`day/ledger.prayerCue`).

// ── 7-2 N22 「잃은 양의 밤」 구출 파라미터 ────────────────────────
// 직전 12분 정본의 진행률을 보존한다: 0:00~6:40 평범한 밤 → 6:40 방향 패널
// → 10:00 자동 발견. 닿으면 자동으로 업는다.
// 필드만 3배 크기 + 카메라 추적(8-4 예외). **"3배"의 축(선형/면적) 해석이 지시서에 없다** —
// 여기서는 **선형 ×3**(면적 9배)으로 잡아 거리 스윕의 상한을 넉넉히 두고,
// ④가 필요 거리를 실측한 뒤 어느 해석이면 충분한지 역으로 판정한다.
// 양 반지름 0.5유닛 = 명세 2장 "1 월드유닛 = 양 몸길이"에서 파생(임의값 아님).
//
// ■ **【10-B 5】 양은 밤의 2/3 지점에 스폰한다 — 조기 발견 봉합.**
//   실측: 초기 거리 40·80유닛에서 **패널이 뜨기 전에 우연히 양을 밟는** 런이 나왔다.
//   그러면 7-2의 "앞 2/3는 평범한 밤"이 거짓말이 되고, 그 밤의 서사(찾아 나선다)가
//   운에 먹힌다. **6:40 전에는 양이 필드에 존재하지 않는다** — 찾을 것이 아직 없다.
//   최소 거리 제약은 **6:40 스폰 시점의 플레이어 위치**를 기준으로 잰다.
export const RESCUE = {
  spawnAt: 480 * NIGHT_DURATION_RATIO, // 8:00 × 5/6 = 6:40, 패널과 동시
  panelAt: 480 * NIGHT_DURATION_RATIO, // 직전 정본의 진행률 2/3 보존
  autoFindAt: NIGHT_SEC,               // 10:00 ("못 찾음"은 없다)
  fieldMult: 3,        // 선형 배수. 해석 주석 위 참조
  sheepR: 0.5 * UNIT,  // 명세 2장 파생
};

// ── 손실 정산표 (3-8) — 밤 평균 안정성 → 그 밤에 잃을 양 수의 배율 ──
// 경계는 지시받은 원안 그대로다. **값을 바꾸지 않았다.**
// 산출기 v2.0이 ×1.0 기준선을 0.35마리/밤으로 역산했다(총 손실 7마리에서).
// ■ **【10-B C-4 재분할】 경계를 목표 곡선의 범위에 맞춘다.**
//   구 표(90/75/60/40)는 아래 두 칸이 **한 번도 안 쓰였다**(실측 표본 0/0).
//   목표 곡선이 N1 94 → N30 61이므로 **정상 플레이는 [61, 94] 안에서만 논다** —
//   60·40 경계는 그 아래라 닿을 수가 없었다. 경계를 그 범위의 4분위로 다시 자른다:
//     94 − 61 = 33 을 넷으로 → 69.3 / 77.5 / 85.8 → **70 / 78 / 86** (5단위 반올림)
//   **최하 칸(40 미만)은 다운 전용이다** — 명세 4-1이 *"다운으로 끝난 밤은 최하 구간을
//   하한으로 확정"*이라고 못박았으므로 정상 플레이가 닿지 않는 것이 정상이고,
//   살려야 할 것은 **위 4칸**이다.
//
// ■ **배율의 절대 크기는 아무것도 정하지 않는다.** 산출기가 `baseLoss` 를 고정점으로
//   풀어 총 손실을 7마리에 맞추므로(`bl = lossTarget / sumMult`), 표가 정하는 것은
//   **밤 사이의 상대 배분**뿐이다. 그래서 배율은 읽기 쉬운 수로 둔다.
export const LOSS_TABLE = [
  { min: 86, mult: 0.0, label: '86%+' },
  { min: 78, mult: 0.5, label: '78~86' },
  { min: 70, mult: 1.0, label: '70~78' },   // ← 장부 기준선
  { min: 40, mult: 2.0, label: '40~70' },
  { min: 0,  mult: 3.0, label: '40 미만 (다운 전용)' },
];
export const LOSS_BASE = 0.25;   // 【10-B】 신 정산표에서 산출기가 재역산한 값(총 손실 7마리 고정점). 임의값 아님

// 다운 = 별도. 밤 중단 + 고정 손실.
// 4장 "쓰러진 시각부터 안정성 급락 — **이른 다운일수록 큰 손실**"이 경사의 근거다.
// base 3.0 = 표의 최악 구간과 접합. slope는 **임의값 — 미검증.**
export const DOWN = { base: 3.0, slope: 3.0 };

// ── 10-A 확정 ① 스폰 곡선 ───────────────────────────────────────
// **예산 13,134 → 17,680.** 병목은 동시 개체 상한이 아니라 **예산**이었다:
//   화면 개체 ≈ 스폰율 × 전이 시간. N1 = 0.41마리/초 × 18초 = 7.4마리(실측 6과 일치).
//   상한 60은 양동이 크기고 수도꼭지는 스폰율이다 — 양동이가 한 번도 안 찼다(점유 0%).
//
// 아래 배수는 개정지시서 10-A 확정 ① 표를 그대로 옮긴 것이다. **임의값 0개.**
//   밤   배수     신 예산   신 상한   (표의 화면 개체)
//   N1   ×4.52    1,324     271       71
//   N3   ×2.58    1,213     206       69
//   N8   ×1.74    1,472     226      115
//   N10  ×1.38    1,442     207      108
//   N12  ×1.11    1,437     200      108
//   N15  ×1.00    1,445     190      103
//   N20  ×1.55    2,310     310      200
//   N22  ×1.24    2,220     310      199
//   N23  ×1.19    2,237     309      199
//   N30  ×1.00    2,580     350      230
// · **구 「N3 스폰 ×1.4」(6-10)는 폐기.** 이 표의 N3 ×2.58에 흡수됐다.
// · **1.0 미만 금지** — N15·N30은 ×1 고정. 스폰을 카드 아래로 내리지 않는다.
// · 회색박스는 종별로 `round(카드 수 × 배수)`를 하므로 총 예산이 표와 **±1** 다를 수 있다
//   (표는 합계를 한 번에 반올림했다). 그 차이는 SPAWN_10A 와 대조해 보고한다.
// ■ **【10-B B】 10-A 곡선 위에 「밴드 보정」이 한 겹 더 얹혔다.**
//   10-A ①은 진척 없는 플레이어 기준이라 진척을 켜자 화면 개체가 밴드 아래로 무너졌다
//   (N8 115 → 31). 밤별 이분 탐색으로 **밴드 중앙을 겨냥한 보정 배수**를 찾았다:
//     N1 ×1.4 · N3 ×1.525 · N8 ×1.65 · N10 ×1.775 · N12 ×1.775 · N15 ×1.9
//     N20 ×1.4 · N22 면제(×1) · N23 ×1.4 · N30 ×1.25
//   보정이 밤 번호에 따라 **오르다가 5장에서 꺾인다** — 앞 장은 플레이어가 세지는 만큼
//   더 넣어야 하고, 5~6장은 10-A가 이미 크게 올려놨기 때문이다.
//   아래 값은 **두 겹을 곱해 접은 최종 배수**다. 10밤 전부 밴드 안(개체 70~275).
// ── 【10-C 재적합 2026-07-28】 카드가 다 도는 위에서 다시 잡았다 ──────
//   구 값은 **카드 2종만 먹던 플레이어** 위의 적합이다(10-B). 13종 + 갈래 + 진화가
//   다 도는 지금은 처치력이 3~5배라 화면이 전 밤 밴드 **아래**로 무너져 있었다
//   (N23 실측 64 / 밴드 200~350). 적합 순서 규율대로 **밴드를 먼저** 채운다.
//   → 배수 2.0~5.9배 상향. 실측 **9/9밤 밴드 안**.
//   CPU 여유 확인: 동시 342(최대 708)에서 step p95 0.61ms = 프레임 예산의 **4%**.
export const SPAWN_MULT = { N1: 12.97, N3: 8.02, N8: 11.14, N10: 8.43, N12: 6.85,
                            N15: 6.20, N20: 9.54, N23: 7.58, N30: 9.33 };
// 10-A 원곡선 — 두 겹의 유래를 남긴다(대조용. 게임 규칙은 위 SPAWN_MULT 하나다).
export const SPAWN_MULT_10A = {
  N1: 4.52, N3: 2.58, N8: 1.74, N10: 1.38, N12: 1.11,
  N15: 1.00, N20: 1.55, N22: 1.24, N23: 1.19, N30: 1.00,
};
// 10-A 표가 기재한 값 — 코드가 표에서 벗어났는지 검산하기 위한 대조군이다(측정값 아님).
export const SPAWN_10A = {
  N1:  { budget: 1324, cap: 271, alive: 71 },
  N3:  { budget: 1213, cap: 206, alive: 69 },
  N8:  { budget: 1472, cap: 226, alive: 115 },
  N10: { budget: 1442, cap: 207, alive: 108 },
  N12: { budget: 1437, cap: 200, alive: 108 },
  N15: { budget: 1445, cap: 190, alive: 103 },
  N20: { budget: 2310, cap: 310, alive: 200 },
  N22: { budget: 2220, cap: 310, alive: 199 },
  N23: { budget: 2237, cap: 309, alive: 199 },
  N30: { budget: 2580, cap: 350, alive: 230 },
};

// ── 표에 없는 밤의 보간 — 【10-B 4】 장 경계에서 계단 ────────────
// 회색박스가 들고 있는 10밤은 전부 10-A 표 안에 있으므로 이 함수는 회색박스 자신을
// 위한 것이 아니라 **캠페인 30밤(원장·산출기)에 이 곡선을 펴기 위한 규칙**이다.
//
// ■ **구 규칙(배수 선형 보간)이 왜 틀렸는가 — 실측이 밝힌 구조적 결함**
//   화면 개체 밴드는 **장 단위 계단**이다(디자인방향 168행 = 헌법 5조):
//     1장 50~100 / 2~4장 100~250 / 5~6장 200~350.
//   그런데 구 규칙은 **배수**를 밤 번호에 대해 매끄럽게 이었다. 밴드가 계단인데
//   그것을 채우는 양이 매끄러우면 경계에서 반드시 어긋난다 — 실측 **8밤 위반**.
//   게다가 배수가 매끄러워도 **카드 예산이 밤마다 다르므로** 결과 개체 수는 매끄럽지도
//   않았다. 구 근거 ⓒ("배수는 평탄해도 된다")가 바로 이 지점에서 틀렸다 — 밴드가
//   제약하는 것은 배수가 아니라 개체 수이고, 그 둘 사이에 카드 예산이 끼어 있다.
//
// ■ **새 규칙 — 배수가 아니라 「목표 화면 개체」를 다룬다.**
//   밴드가 제약하는 것을 직접 정하고 배수는 거기서 역산한다.
//   그러면 **밴드 위반이 구조적으로 0이 된다**(clamp 가 곧 계단이다).
//     ① 목표 개체 = 10-A ① 표의 `alive` 를 밤 번호로 선형 보간
//     ② **그 밤이 속한 장의 밴드로 clamp** ← 여기가 계단이다
//     ③ 배수 = 목표 개체 ÷ (카드 예산 × ρ),  ρ = 그 밤의 전이 비율(= alive ÷ 예산)
//        ρ 도 앵커에서 보간한다. 같은 예산이라도 적 구성이 다르면 화면에 남는 수가
//        다르기 때문이다 — 정예는 느리고 질겨서 오래 머문다(실측 ρ 0.054~0.090).
//     ④ **하한 1.0**(10-A). 어떤 밤도 카드 예산 아래로 내려가지 않는다.
//   구 근거 ⓐ(카드의 굴곡 보존)는 새 규칙에서도 살아 있다 — 예산이 아니라 목표 개체를
//   보간하고 카드 예산으로 나누므로, 카드가 낮은 밤은 배수가 높아질 뿐 예산이 부풀지 않는다.
//
// ■ **앵커 10밤은 10-A 확정 배수를 그대로 쓴다.** 보간은 비앵커 20밤만의 문제다 —
//   앵커는 실측으로 확정된 값이므로 재유도로 ±0.5% 흔들 이유가 없다.
//
// ■ **밴드 면제 — 카드가 의도적으로 밀도를 낮춘 밤.**
//   N13(안개 895)·N17(도강 400)은 예산이 낮은 것이 설계다. 밴드를 강제하면 그 밤들이
//   밴드 하한까지 부풀어 성격이 지워진다. **그 밤들은 밀도가 아니라 다른 것으로 성격을 낸다.**
//   N22(구출)는 필드가 3배라 화면 밀도의 자가 다르고, N16·N21은 정적 밤(예산 0)이라
//   무엇을 곱해도 0이다.
// ══════════════════════════════════════════════════════════════════
//  ⚠⚠ **아래 세 표는 「구 카드 번호」로 키를 잡는다 — 날짜가 아니다** 【40일 개편】
//
//  `CARD_BUDGET` · `CARD_CAP` · `BAND_EXEMPT` 는 30밤시트 카드에 붙은 값이다.
//  40일로 옮기면서 **카드와 날짜가 갈렸다**(예: 카드 N24「식탁」은 31일에 선다).
//  그러니 여기 1~30 은 **그 카드**를 뜻하지 며칠째를 뜻하지 않는다.
//
//  ⚠ 그런데 아래 `targetAliveFor`·`spawnMultFor` 는 `chapterOf(nightNo)` 를 부르고,
//    `chapterOf` 는 이제 **날짜 기준**(7일마다)이다. **두 좌표계가 한 식에 섞인다.**
//    → 이 파생 함수들은 **실행 코드가 안 쓴다.** 런타임은 카드에 박혀 있는
//      `NIGHTS[nk].spawnMult` 를 그대로 읽는다(`spawnMultOf`). 쓰는 것은 옛 측정
//      프로브(화석)뿐이고, 그것들은 30밤 좌표에서 돌던 것이다.
//    ⚠ **새 코드에서 부르지 마라.** 물량을 다시 잡을 일이 오면 이 표부터 날짜로
//      옮기고(또는 카드 좌표 전용임을 명시하고) 그 다음에 손대야 한다.
// ══════════════════════════════════════════════════════════════════
export const CARD_BUDGET = { 1:293, 2:380, 3:470, 4:560, 5:620, 6:780, 7:670, 8:846, 9:995, 10:1045,
  11:1195, 12:1295, 13:895, 14:1492, 15:1445, 16:0, 17:400, 18:1642, 19:1692, 20:1490,
  21:0, 22:1790, 23:1880, 24:1585, 25:2275, 26:2090, 27:2385, 28:1795, 29:2190, 30:2580 };
export const CARD_CAP = { 1:60, 2:70, 3:80, 4:95, 5:100, 6:140, 7:120, 8:130, 9:150, 10:150,
  11:170, 12:180, 13:140, 14:200, 15:190, 16:0, 17:70, 18:210, 19:220, 20:200,
  21:0, 22:250, 23:260, 24:220, 25:300, 26:280, 27:320, 28:260, 29:300, 30:350 };
// ══════════════════════════════════════════════════════════════════
//  **여정의 길이와 안식일** 【사장님 지시 2026-08-03】
//    40일. 7일마다 안식일(7·14·21·28·35 — 다섯 번). 40일째가 보스이자 끝.
//    ⚠ 40일은 안식일이 아니다 — 마지막 날은 쉬지 않는다.
//    자세한 배치는 아래 `DAY_PLAN` 에 있다. 여기 상수가 먼저 오는 것은
//    `chapterOf` 가 바로 아래에서 이 값을 쓰기 때문이다.
// ══════════════════════════════════════════════════════════════════
export const SABBATH_EVERY = 7;
export const CAMPAIGN_DAYS = 40;
export const isSabbath = (day) => day % SABBATH_EVERY === 0 && day < CAMPAIGN_DAYS;

// ── 40일 난이도 목표 곡선의 두 상수 【사장님 확정 2026-08-03】 ──────
//   *"밤1이 딱 적당해. 밤 2부터는 그보다 아주 살짝씩 어려워져야해."*
//   앵커 94 = 카드 N1 원장값 그대로 · 걸음 1.0/전투밤 = 35전투밤 평균이 정확히
//   77.0(원장의 「전투 밤 평균 77%」)이 되는 유일한 직선 기울기. 적용은
//   buildNights() 끝의 목표 곡선 패스 — 유래·대체된 구 곡선·톱니 폐기는 거기 주석.
export const STAB_TARGET_ANCHOR = 94;
export const STAB_TARGET_STEP = 1.0;

// ⚠ **장은 안식일이 끊는다** 【사장님 지시 2026-08-03 — *"안식일 다음날이 다음장"*】.
//   구 값은 30일을 4·5·5·4·7·5 로 나눈 손 표였다(1-4 / 5-9 / 10-14 / 15-18 / 19-25 / 26-30).
//   이제 7일이 한 장이다: **1-7 · 8-14 · 15-21 · 22-28 · 29-35 · 36-40**.
//   마지막 장만 5일인데(36~40), 쉬는 날 없이 보스로 달리는 구간이라 그게 맞다.
//   ⚠ 들판 그림도 마침 6장이라 장과 1:1 로 붙는다(`fieldart.js`).
//   ⚠ 값을 35 로 자르지 말 것 — 한 번 그렇게 짰다가 **36~40 이 5장으로 밀렸다.**
//     마지막 장은 7일이 아니라 5일(36~40)이고, `ceil(40/7)=6` 이 그걸 그대로 낸다.
export const chapterOf = (n) =>
  Math.max(1, Math.min(6, Math.ceil((n ?? 1) / SABBATH_EVERY)));
export const BAND = { 1: [50, 100], 2: [100, 250], 3: [100, 250], 4: [100, 250], 5: [200, 350], 6: [200, 350] };
// **보스 밤(28·29·30)을 면제에 넣는다** — 사장님 결정 ⓑ.
//   30밤시트가 보스 활성 중 물량층 스폰 **−40%**를 걸어 두었고(BOSS_SWARM_CUT),
//   그 조항의 근거가 *"배후를 잡으려면 / 계속 도망 다니려면 **이동할 공간이 있어야
//   한다**"* 이다. 밴드를 전 밤 균일하게 강제하면 그 −40%가 묻힌다.
//   N13·N17 이 이미 「카드가 의도적으로 밀도를 낮춘 밤」으로 면제돼 있으므로
//   **같은 문법이다** — 새 규칙을 만들지 않는다.
export const BAND_EXEMPT = new Set([13, 16, 17, 21, 22, 28, 29, 30]);

// 앵커의 (밤, 목표 화면 개체, 전이 비율 ρ) — 전부 10-A ① 표에서 파생. 지어낸 값 0개.
const ALIVE_ANCHORS = Object.entries(SPAWN_10A)
  .map(([k, v]) => [+k.slice(1), v.alive, v.alive / v.budget])
  .sort((a, b) => a[0] - b[0]);
function lerpAnchor(nightNo, col) {
  const A = ALIVE_ANCHORS;
  if (nightNo <= A[0][0]) return A[0][col];
  if (nightNo >= A.at(-1)[0]) return A.at(-1)[col];
  for (let i = 1; i < A.length; i++) {
    if (nightNo <= A[i][0]) {
      const x0 = A[i - 1][0], y0 = A[i - 1][col], x1 = A[i][0], y1 = A[i][col];
      return y0 + (y1 - y0) * (nightNo - x0) / (x1 - x0);
    }
  }
  return A.at(-1)[col];
}
// 그 밤이 노리는 화면 개체 — 밴드 clamp 가 「계단」이다. **면제 밤에는 목표가 없다.**
export function targetAliveFor(nightNo) {
  if (BAND_EXEMPT.has(nightNo)) return null;
  const [lo, hi] = BAND[chapterOf(nightNo)];
  return Math.min(hi, Math.max(lo, lerpAnchor(nightNo, 1)));
}
export function spawnMultFor(nightNo) {
  const anchor = SPAWN_MULT['N' + nightNo];
  if (anchor != null) return anchor;                    // 앵커 = 10-A 확정값 그대로
  const cb = CARD_BUDGET[nightNo] ?? 0;
  if (cb <= 0) return 1;                                // 정적 밤 — 무엇을 곱해도 0이다
  if (!BAND_EXEMPT.has(nightNo))
    return Math.max(1, targetAliveFor(nightNo) / (cb * lerpAnchor(nightNo, 2)));

  // ■ **면제 밤에 목표 개체를 먹이면 안 된다 — 첫 구현에서 이걸 틀렸다.**
  //   N17(도강)은 카드 예산 400이고 목표 개체를 먹이면 배수가 **×4.58**이 되어
  //   예산이 400 → 1,832으로 4.6배 부푼다. 그것은 내가 구 규칙을 비판한 바로 그
  //   병리(카드의 설계 의도를 보간이 지운다)를 방향만 바꿔 되풀이하는 것이다.
  //   면제의 뜻은 *"이 밤은 밀도로 성격을 내지 않는다"*이므로 **목표를 주지 않는다.**
  // ■ 그래도 배수 1.0으로 고정하지는 않는다 — 캠페인 난이도 램프는 타야 한다.
  //   (무기·요령은 밤마다 세지는데 카드값 그대로면 그 밤만 공짜가 된다.)
  //   **이웃한 비면제 밤의 배수로 선형 보간한다.** 카드의 낮은 예산은 그대로 살고,
  //   램프만 얹힌다. 정적 밤(예산 0)은 이웃 후보에서 건너뛴다.
  let lo = nightNo - 1, hi = nightNo + 1;
  while (lo >= 1 && (BAND_EXEMPT.has(lo) || (CARD_BUDGET[lo] ?? 0) <= 0)) lo--;
  while (hi <= 30 && (BAND_EXEMPT.has(hi) || (CARD_BUDGET[hi] ?? 0) <= 0)) hi++;
  const ml = lo >= 1 ? spawnMultFor(lo) : null;         // 이 재귀는 비면제로만 내려간다
  const mh = hi <= 30 ? spawnMultFor(hi) : null;
  if (ml == null && mh == null) return 1;
  if (ml == null) return mh;
  if (mh == null) return ml;
  return Math.max(1, ml + (mh - ml) * (nightNo - lo) / (hi - lo));
}
// 그 배수를 적용했을 때 **투영되는** 화면 개체. 밴드 검사는 이 값으로 한다.
// 앵커 밤은 실측 alive 를 그대로 돌려준다(투영이 아니라 측정값이다).
export function projectedAliveFor(nightNo) {
  const a = SPAWN_10A['N' + nightNo];
  if (a) return a.alive;
  const cb = CARD_BUDGET[nightNo] ?? 0;
  if (cb <= 0) return 0;
  return cb * spawnMultFor(nightNo) * lerpAnchor(nightNo, 2);
}

// ── 밤 카드 10장 — 30밤시트 카드 + 원장 산출기 v2.0 정본 ─────────
// ①이 캠페인 곡선(N1 94 → N10 83 → N20 74 → N30 61)을 역산하려면 그 앵커를 다 덮어야 한다.
// 그래서 직전 7장에 **N10 · N20 · N22**를 더해 10장으로 늘렸다.
//   1장 N1·N3 / 2장 N8 / 3장 N10·N12 / 4장 N15 / 5장 N20·N22·N23 / 6장 N30
//
// spawn — 30밤시트 카드의 종별 분해를 6-1 3층 구조로 접은 것. 합계는 원장과 일치한다.
//   **위협층(독수리)은 회색박스에 없다** — 공중 유닛이라 지상 접촉 모델 밖이다.
//   도둑은 4-8로 삭제됐다. **N30의 곰·N29의 사자도 없다**(6-2 보스 상태기계).
// concurrent / flock / ledgerStab / ledgerKills / ledgerPieces — 전부 tools/economy_gen.mjs
//   **v2.0** 출력(직전 회색박스는 v1.0 값이었다 — 67da521의 드리프트 경고를 여기서 해소한다).
//   ledgerStab이 그 밤의 **목표 평균 안정성**이다(명세 5장 캠페인 곡선의 정본 구현).
//
// ■ **`multExempt` — 밤별 스폰 배수를 받지 않는 층.** 현재 쓰는 밤은 **N1 하나뿐이다.**
//   기본 규칙은 「모든 층에 그 밤의 배수를 곱한다」이고, 이 필드는 그 규칙의 유일한 예외다.
//   예외를 새 밤에 늘리려면 **서사 쪽에 그 수를 못 박는 문장이 먼저 있어야 한다** — 아래 N1 주석 참조.
const CARD = {
  N1: {
    name: '밤 1 — 첫 밤',
    teaches: '첫 밤. 늑대층 원장 3칸(비율 추첨).',
    spawn: { swarm: 290, elite: 3 },
    // ── **N1 전용 예외 — 늑대층 raw 통장 3칸은 배수 밖에 둔다.** ──
    //   이 값은 등장 보장이 아니라 전체 통장에서 비율 추첨되는 원자료다. 배수를 먹이면
    //   3칸이 19칸까지 불어나 첫 밤의 정예 비중 자체가 달라지므로 정예층만 배수 밖에 둔다.
    //   실제 등장 수는 스폰 총량·추첨·리필에 따라 달라지고, 물량층(들쥐)은 배수를 그대로
    //   받는다. 다른 밤에는 이런 별도 원자료 계약이 없어 예외도 N1 하나뿐이다.
    multExempt: ['elite'],
    concurrent: 60, howl: true,
    spawnMult: 12.97,   // 【10-C】 구 6.33 → 밴드 재적합
    flock: 20, ledgerStab: 94.0, ledgerKills: 278,
    ledgerPieces: 406, gbPieces: 406, threatCut: 0,
  },
  N3: {
    name: '밤 3 — 들개의 밤',
    teaches: '크기 = 정보. 큰 놈은 훨씬 아프다.',
    spawn: { swarm: 450, elite: 20 },      // 들쥐300+들개150 / 우두머리15+늑대5
    concurrent: 80, howl: true,
    spawnMult: 8.02,   // 【10-C】 구 3.93 → 밴드 재적합
    flock: 20, ledgerStab: 91.8, ledgerKills: 447,
    ledgerPieces: 776, gbPieces: 776, threatCut: 0,
  },
  N8: {
    name: '밤 8 — 그림자의 밤',
    teaches: '독수리 데뷔 — 회색박스에는 없다(공중 유닛).',
    spawn: { swarm: 812, elite: 34 },      // 자칼420+들쥐392 / 늑대34 (독수리 4 제외)
    concurrent: 130, howl: true,
    spawnMult: 11.14,   // 【10-C】 구 2.87 → 밴드 재적합
    flock: 25, ledgerStab: 85.1, ledgerKills: 808,
    ledgerPieces: 1494, gbPieces: 1380, threatCut: 4,
  },
  N10: {
    name: '밤 10 — 협곡의 밤',
    teaches: '협곡 데뷔 — 지형은 회색박스에 없다(적은 사방에서 온다).',
    spawn: { swarm: 1000, elite: 45 },     // 들쥐600+자칼400 / 늑대45 (독수리 5 제외)
    concurrent: 150, howl: true,
    spawnMult: 8.43,   // 【10-C】 구 2.45 → 밴드 재적합
    flock: 26, ledgerStab: 82.4, ledgerKills: 998,
    ledgerPieces: 1872, gbPieces: 1822, threatCut: 5,
  },
  N12: {
    name: '밤 12 — 매복의 밤',
    teaches: '하이에나 데뷔. 하울링 없는 정예 — **소리의 장(2장) 다음에 소리 없는 사냥꾼**이 온다. 양을 노리는 놈이라 보호 근육의 예습이다. 개 짖음은 **연출**이다(2-7).',
    spawn: { swarm: 1240, elite: 15, hyena: 40 },
    concurrent: 180, howl: false,
    spawnMult: 6.85,   // 【10-C】 구 1.97 → 밴드 재적합
    flock: 28, ledgerStab: 78.0, ledgerKills: 1235,
    ledgerPieces: 2279, gbPieces: 2136, threatCut: 5,
  },
  N15: {
    name: '밤 15 — 비의 밤',
    teaches: '비 — 적 이속 감소(회색박스 미구현).',
    spawn: { swarm: 1390, elite: 25, hyena: 30 },  // 들쥐700+자칼500+박쥐190 / 늑대25 / 하이에나30
    concurrent: 190, howl: true,
    spawnMult: 6.20,   // 【10-C】 구 1.9 → 밴드 재적합
    flock: 31, ledgerStab: 75.7, ledgerKills: 1378,
    ledgerPieces: 2474, gbPieces: 2332, threatCut: 5,
  },
  N20: {
    name: '밤 20 — 빈 들의 밤',
    teaches: '맑음 · 폐허 · **정적-후-쇄도(hush-eased)** — 7분 가까운 희박한 정찰 뒤, 마지막 3분여의 쇄도가 완만하게 열린다. 기존 정적의 물량은 유지하고 첫 충돌 절벽만 누그러뜨린다. (구 도둑 데뷔 — 4-8 삭제. 그 빈 자리를 파형이 채웠다 · 리듬 개편 2026-08-08)',
    spawn: { swarm: 1420, elite: 20, hyena: 50 },  // 까마귀600+들쥐450+자칼370 / 늑대20 / 하이에나50
    concurrent: 200, howl: true,
    spawnMult: 9.54,   // 【10-C】 구 2.17 → 밴드 재적합
    flock: 38, ledgerStab: 71.8, ledgerKills: 1416,
    ledgerPieces: 2513, gbPieces: 2513, threatCut: 0,
  },
  N23: {
    name: '밤 23 — 세 방향의 밤',
    teaches: '바람(하울링 무효) · **이중봉(twin) + 부채꼴 3(arcs)** — 소리는 없고 방향은 셋이다. 듣지 말고 읽어라. (구 도둑 떼 — 4-8 삭제 · 리듬 개편 2026-08-08)',
    spawn: { swarm: 1780, elite: 30, hyena: 70 },  // 까마귀800+들쥐550+자칼430 / 늑대30 / 하이에나70
    concurrent: 260, howl: false,
    spawnMult: 7.58,   // 【10-C】 구 1.67 → 밴드 재적합
    flock: 39, ledgerStab: 62.6, ledgerKills: 1786,
    ledgerPieces: 3267, gbPieces: 3267, threatCut: 0,
  },
  N30: {
    name: '밤 30 — 사자의 밤',
    teaches: '최종. **사자는 회색박스에 없다**(6-2 보스 상태기계).',
    spawn: { swarm: 2440, elite: 30, hyena: 110 },
    concurrent: 350, howl: true,
    // ⚠ **이 값은 신뢰할 수 없다.** 9.33 은 밴드 적합이 낸 수인데, 그 측정 동안
    //   플레이어가 60~100초에 죽어 **12분치가 아니라 1분치를 잰 값**이다.
    //   보스 밤은 밴드 면제로 돌렸으므로(BAND_EXEMPT) 이웃 밤(N23 7.58)에서
    //   장 예산비로 내린 잠정값을 쓴다. **곰 접촉 문제가 닫힌 뒤 재측정한다.**
    spawnMult: 5.00,   // 【10-C 잠정】 측정 대기 — 아래 주석
    flock: 38, ledgerStab: 60.5, ledgerKills: 2460,
    ledgerPieces: 6262, gbPieces: 4506, threatCut: 9,
    // gbPieces < ledgerPieces 격차의 대부분은 **곰 고정 보상**이다(보스는 회색박스에 없다).
  },
  // ══════════════════════════════════════════════════════════════
  //  나머지 20밤 — **여기부터는 앵커가 아니다.**
  //
  //  ■ 위 10밤은 10-A 실측 앵커다. 아래 20밤은 **한 줄도 새로 설계하지 않았고**,
  //    전부 이미 있는 정본에서 옮겨 왔다:
  //      name / question / teaches — 30밤시트 그 밤의 카드 (문장 그대로)
  //      spawn 물량·정예·하이에나  — economy_gen 의 nights 표 나누기 그 밤 배수
  //                                  (합계가 CARD_BUDGET 과 오차 3 안에서 일치 — 전건 대조)
  //      concurrent               — CARD_CAP[n]  (앵커 10밤도 전건 이 값이다)
  //      spawnMult                — spawnMultFor(n). 이 파일이 이미 구현한 10-A 보간 규칙
  //      threatCut                — economy_gen 의 같은 표
  //
  //  ■ ⚠ **원장 다섯(flock·ledgerStab·ledgerKills·ledgerPieces·gbPieces)은 같은 장의
  //    가장 가까운 앵커에서 베꼈다** — 사장님 지시. 줄 끝에 어느 밤에서 왔는지 적었다.
  //    산출기에 30밤 값이 있지만 **앵커 10밤이 옛 스냅샷 위에 있어서**(원장 표 134칸
  //    불일치 — 이미 기록된 위반) 그것을 쓰면 한 표 안에 스냅샷이 둘이 된다.
  //    **원장 재스냅샷 때 이 20밤도 같이 간다.**
  //
  //  ■ ⚠ **정적 밤 N16·N21 의 안정성 100 은 지어낸 값이 아니다** — 30밤시트가
  //    "안정성 100% 확정 → 우유 만액" 이라고 적은 그대로다. 스폰·킬·조각은 0.
  //
  //  ■ ⚠ **LEVEL_STEP_MEASURED 는 앵커 10밤만 갖고 있다.** 아래 20밤은 그 표에 없어
  //    구 경로(ledgerPieces 기반)를 탄다 — 레벨업 횟수가 목표보다 부풀 수 있다.
  //    **측정 대기**이며 지어내지 않는다(명세 6-4a).
  //
  //  ■ ⚠ **보스는 회색박스에 없다**(6-2). N28 곰 · N29 사자는 카드에만 적혀 있고
  //    스폰 표에는 물량·정예만 있다 — 앵커 N30 과 같은 처리다.
  // ══════════════════════════════════════════════════════════════
  N2: {
    name: '밤 2 — 주머니의 밤',
    teaches: '맑음 · 개활지 · 가르침 — 레벨업 상점의 값이 데뷔한다.',
    spawn: { swarm: 366, elite: 14 },
    concurrent: 70, howl: true,
    spawnMult: 3.33,
    flock: 20, ledgerStab: 94, ledgerKills: 278,
    ledgerPieces: 406, gbPieces: 406, threatCut: 0,   // 원장 ← N1
  },
  N4: {
    name: '밤 4 — 첫 시험의 밤',
    teaches: '맑음 · 개활지 · 시험(1장 피크) — 1장 총합, 신규 없음.',
    spawn: { swarm: 510, elite: 50 },
    concurrent: 95, howl: true,
    spawnMult: 2.28,
    flock: 20, ledgerStab: 91.8, ledgerKills: 447,
    ledgerPieces: 776, gbPieces: 776, threatCut: 0,   // 원장 ← N3
  },
  N5: {
    name: '밤 5 — 승냥이의 밤',
    teaches: '맑음 · 개활지 · **1장 클라이맥스(물량)** — 자칼 데뷔, 소모전의 밤. 밤 끝에 **먼 하울링**(2장 예고 · 연출 대기). 클라이맥스 로테이션의 첫째 — 첫 주의 적은 보스가 아니라 밤 자체다.',
    spawn: { swarm: 592, elite: 28 },
    concurrent: 100, howl: true,
    spawnMult: 2.47,
    flock: 25, ledgerStab: 85.1, ledgerKills: 808,
    ledgerPieces: 1494, gbPieces: 1380, threatCut: 0,   // 원장 ← N8
  },
  N6: {
    name: '밤 6 — 메뚜기의 밤',
    teaches: '맑음 · 개활지 · 가르침 — 메뚜기 떼 데뷔 — 크기는 물량층인데 이동이 다르다(폴짝).',
    spawn: { swarm: 756, elite: 24 },
    concurrent: 140, howl: true,
    spawnMult: 1.84,
    flock: 25, ledgerStab: 85.1, ledgerKills: 808,
    ledgerPieces: 1494, gbPieces: 1380, threatCut: 0,   // 원장 ← N8
  },
  N7: {
    name: '밤 7 — 돌밭의 밤',
    teaches: '맑음 · 개활지 · 조합 — 출산은 그날 낮으로 이관됐다(명세 4-1·8장).',
    spawn: { swarm: 640, elite: 30 },
    concurrent: 120, howl: true,
    spawnMult: 2.14,
    flock: 25, ledgerStab: 85.1, ledgerKills: 808,
    ledgerPieces: 1494, gbPieces: 1380, threatCut: 0,   // 원장 ← N8
  },
  N9: {
    name: '밤 9 — 바람 부는 밤',
    teaches: '바람 · 개활지 · 뒤집기(2장 피크) — 하울링 마스킹 — 큐 1을 끄지 않고 들릴 듯 말 듯 재생한다.',
    spawn: { swarm: 960, elite: 35 },
    concurrent: 150, howl: false,
    spawnMult: 1.46,
    flock: 25, ledgerStab: 85.1, ledgerKills: 808,
    ledgerPieces: 1494, gbPieces: 1380, threatCut: 5,   // 원장 ← N8
  },
  N11: {
    name: '밤 11 — 박쥐의 밤',
    teaches: '맑음 · 협곡 · 가르침 — 박쥐 데뷔.',
    spawn: { swarm: 1149, elite: 45 },
    concurrent: 170, howl: true,
    spawnMult: 1.20,
    flock: 26, ledgerStab: 82.4, ledgerKills: 998,
    ledgerPieces: 1872, gbPieces: 1822, threatCut: 5,   // 원장 ← N10
  },
  N13: {
    name: '밤 13 — 안개의 밤',
    teaches: '안개 · 협곡 · 고정+뒤집기(회전축) — 소년이 길을 잃는다 — 서리가 앞장서고, 플레이어가 따라간다.',
    spawn: { swarm: 860, elite: 0, hyena: 35 },
    concurrent: 140, howl: true,
    spawnMult: 3.92,
    flock: 28, ledgerStab: 78, ledgerKills: 1235,
    ledgerPieces: 2279, gbPieces: 2136, threatCut: 5,   // 원장 ← N12
  },
  N14: {
    name: '밤 14 — 바닥의 밤',
    teaches: '맑음 · 협곡 · 시험(3장 피크) — 3장 총합(박쥐 + 하이에나 + 협곡), 신규 없음.',
    spawn: { swarm: 1430, elite: 17, hyena: 45 },
    concurrent: 200, howl: true,
    spawnMult: 1.00,
    flock: 28, ledgerStab: 78, ledgerKills: 1235,
    ledgerPieces: 2279, gbPieces: 2136, threatCut: 8,   // 원장 ← N12
  },
  N17: {
    name: '밤 17 — 도강의 밤',
    teaches: '맑음 · 강 · 고정+시험 — 카드가 의도적으로 밀도를 낮춘 밤(밴드 면제).',
    spawn: { swarm: 390, elite: 10 },
    concurrent: 70, howl: true,
    spawnMult: 2.88,
    flock: 31, ledgerStab: 75.7, ledgerKills: 1378,
    ledgerPieces: 2474, gbPieces: 2332, threatCut: 0,   // 원장 ← N15
  },
  N18: {
    name: '밤 18 — 건너편의 밤',
    teaches: '맑음 · 개활지 · 시험(4장 피크) — 신규 없음.',
    spawn: { swarm: 1580, elite: 27, hyena: 35 },
    concurrent: 210, howl: true,
    spawnMult: 1.22,
    flock: 31, ledgerStab: 75.7, ledgerKills: 1378,
    ledgerPieces: 2474, gbPieces: 2332, threatCut: 8,   // 원장 ← N15
  },
  N19: {
    name: '밤 19 — 까마귀의 밤',
    teaches: '맑음 · 개활지 · 가르침(장 첫 밤) — 까마귀 떼 데뷔 — 스폰 무한 보충, 마르지 않는 첫 적.',
    spawn: { swarm: 1630, elite: 22, hyena: 40 },
    concurrent: 220, howl: true,
    spawnMult: 1.42,
    flock: 38, ledgerStab: 71.8, ledgerKills: 1416,
    ledgerPieces: 2513, gbPieces: 2513, threatCut: 8,   // 원장 ← N20
  },
  N24: {
    name: '밤 24 — 식탁의 낮과 폐허의 밤',
    teaches: '맑음 · 폐허 · 조합(+낮 고정 서사) — 식탁은 그날 낮에 일어난다. 밤은 평범한 폐허 맵의 밤이며 새 전투 규칙이 0개다.',
    spawn: { swarm: 1500, elite: 25, hyena: 60 },
    concurrent: 220, howl: true,
    spawnMult: 1.44,
    flock: 39, ledgerStab: 62.6, ledgerKills: 1786,
    ledgerPieces: 3267, gbPieces: 3267, threatCut: 0,   // 원장 ← N23
  },
  N25: {
    name: '밤 25 — 전쟁의 밤',
    teaches: '비 · 개활지 · 시험(5장 피크·후반 물량 진입) — 신규 없음.',
    spawn: { swarm: 2151, elite: 35, hyena: 90 },
    concurrent: 300, howl: true,
    spawnMult: 1.03,
    flock: 39, ledgerStab: 62.6, ledgerKills: 1786,
    ledgerPieces: 3267, gbPieces: 3267, threatCut: 0,   // 원장 ← N23
  },
  N26: {
    name: '밤 26 — 언덕의 밤',
    teaches: '맑음 · 언덕 · 가르침(장 첫 밤) — 언덕 재해석 — 별이 가장 많은 밤, 6장의 톤은 엄숙.',
    spawn: { swarm: 2000, elite: 20, hyena: 70 },
    concurrent: 280, howl: true,
    spawnMult: 1.14,
    flock: 38, ledgerStab: 60.5, ledgerKills: 2460,
    ledgerPieces: 6262, gbPieces: 4506, threatCut: 0,   // 원장 ← N30
  },
  N27: {
    name: '밤 27 — 지나온 모든 밤',
    teaches: '맑음 · 개활지 · 시험 — 전 장 위협 리프라이즈(메뚜기 제외 — 생태 정합).',
    spawn: { swarm: 2271, elite: 35, hyena: 81 },
    concurrent: 320, howl: true,
    spawnMult: 1.02,
    flock: 38, ledgerStab: 60.5, ledgerKills: 2460,
    ledgerPieces: 6262, gbPieces: 4506, threatCut: 8,   // 원장 ← N30
  },
  N28: {
    name: '밤 28 — 빗속의 협곡',
    teaches: '비 · 협곡 · 고정+뒤집기 — 좁은 시야와 물량을 견디는 마지막 일반전.',
    spawn: { swarm: 1719, elite: 5, hyena: 70 },
    concurrent: 260, howl: true,
    spawnMult: 1.02,
    flock: 38, ledgerStab: 60.5, ledgerKills: 2460,
    ledgerPieces: 6262, gbPieces: 4506, threatCut: 0,   // 원장 ← N30
  },
  N29: {
    name: '밤 29 — 곰의 밤',
    teaches: '맑음 · 개활지 · 고정+시험(보스) — 곰 — 회색박스에 보스는 없다(6-2 보스 상태기계).',
    spawn: { swarm: 2080, elite: 10, hyena: 101 },
    concurrent: 300, howl: true,
    spawnMult: 1.02,
    flock: 38, ledgerStab: 60.5, ledgerKills: 2460,
    ledgerPieces: 6262, gbPieces: 4506, threatCut: 0,   // 원장 ← N30
  },
};

// ══════════════════════════════════════════════════════════════════
//  **40일 — 안식일을 포함한 여정**   【사장님 지시 2026-08-03】
//
//  ■ 무엇이 바뀌었나
//     · 30일 → **40일.** 7일마다 안식일(7·14·21·28·35) — **5번**.
//     · 전투 밤 **35**, 안식일 **5**. 40일째가 보스이자 끝이다.
//     · **잃은 양의 밤(구 N22) 삭제** — 밤에 양이 나오는 유일한 예외였다.
//       잃은 양은 이제 **마지막 밤 화살표 끝에서** 만난다.
//     · **정적 밤(구 N16 소생 · N21 가장 평화로운)을 안식일이 흡수한다.**
//       둘 다 *"전투 없음 — 안정성 100% 확정"* 이라 안식일과 **같은 물건**이었다.
//       남겨 두면 「쉬는 날」이 두 종류가 되어 규칙이 흐려진다.
//     · **장은 안식일이 끊는다** — 1·8·15·22·29·36 일에 새 장. 6장이고,
//       들판 그림이 마침 6장이라 딱 맞는다(`fieldart.js`).
//
//  ■ ⚠ **밤의 리듬(물량 곡선)은 새로 설계하지 않았다** — 사장님 지시 그대로다.
//    구 30밤 카드의 `spawn`·`concurrent`·`spawnMult` 을 **그 카드에 붙여 그대로**
//    옮겼다. 카드가 몇 일째로 가든 그 밤의 물량은 안 변한다.
//    빈 8칸만 **양옆 카드의 가운데값**으로 채운다 — 지어낸 값이 아니라 보간이다
//    (이 파일이 `lerpAnchor` 로 이미 쓰는 문법).
//
//  ■ ⚠ **카드 표(`CARD`)를 날짜로 다시 쓰지 않았다.** 구 카드는 30밤시트 정본이고
//    한 장 한 장에 근거 주석이 붙어 있다. 날짜를 키로 다시 쓰면 그 주석이
//    **어느 밤 것인지 알 수 없게 된다.** 그래서 카드는 그대로 두고
//    **배치표(`DAY_PLAN`) 한 줄**로 날짜에 앉힌다. 목사님 자문 뒤 순서가 바뀌면
//    **이 배열 하나만** 고치면 된다.
// ══════════════════════════════════════════════════════════════════

// (여정 길이·안식일 주기는 이 파일 위쪽에 있다 — `chapterOf` 가 먼저 쓰기 때문이다)

// ── 빈 8칸 ────────────────────────────────────────────────────────
//  ⚠⚠ **이 여덟 장은 내가 지었다. 정본이 아니다.**  【사장님: *"분위기 맞게 너가
//    임의로 넣고, 나중에 내가 한번에 검수"*】. 그래서 `draft: true` 를 달아
//    30밤시트에서 온 카드와 **눈으로 구별되게** 했다. 검수 때 이것만 보면 된다.
//  ⚠ 새 적·새 규칙은 하나도 안 만들었다 — 전부 *"신규 없음"* 이다. 날씨·지형·유형은
//    양옆 카드를 따랐다. 물량은 아래에서 **이웃의 가운데값**으로 자동으로 잡힌다.
const DRAFT = {
  D4:  { name: '마른 바람의 밤', teaches: '맑음 · 개활지 · 조합(파도형 데뷔) — 1장 물량이 처음으로 겹치되 **파도로** 온다. 파도 사이 정적이 우물의 시간이다.' },
  D9:  { name: '돌무더기의 밤', teaches: '맑음 · 개활지 · 조합(파도형) — 2장 데뷔들이 파도로 겹친다.' },
  D13: { name: '무리의 밤', teaches: '맑음 · 개활지 · **클라이맥스(무리전)** — 정예 셋이 삼각으로 함께 온다(pack ×3회). 2장 내내 울던 하울링의 근원은 한 마리가 아니라 무리였다. (구 「마지막 파수의 밤」 — 리듬 개편 2026-08-08)' },
  D18: { name: '그늘진 등성이의 밤', teaches: '맑음 · 협곡 · 조합(파도형) — 3장 물량이 파도로 두꺼워진다.' },
  D23: { name: '젖은 자갈의 밤', teaches: '비 · 개활지 · 조합(파도형) — 비가 두 밤 이어진다. 인내의 밤.' },
  D27: { name: '폭풍의 밤', teaches: '폭풍(비+바람) · 폐허 · **클라이맥스(보호)** — 하울링 무효, 담이 무너져 시작 안정성 85. 보스 없이 자연이 보스다. (구 「무너진 담의 밤」 — 리듬 개편 2026-08-08)' },
  D32: { name: '잿빛의 밤', teaches: '비 · 폐허 · 조합(파도형) — 5장 후반 물량 구간.' },
  D37: { name: '숨죽인 밤', teaches: '맑음 · 개활지 · **정적-후-쇄도(hush)** — 29일보다 더 깊고 가파른 침묵이 돌아온다. 이번엔 알고 기다린다. 보스 앞 마지막 밤.' },
};

// ── 배치표 — 40칸. 'SAB' 는 안식일, 'D…' 는 위의 초안 ─────────────
//  구 카드는 **순서를 그대로** 지켰다(첫 밤 → … → 곰). 보스 셋은 끝 사흘이다.
const DAY_PLAN = [
  /*  1 */ 'N1',  /*  2 */ 'N2',  /*  3 */ 'N3',  /*  4 */ 'D4',
  /*  5 */ 'N4',  /*  6 */ 'N5',  /*  7 */ 'SAB',
  /*  8 */ 'N6',  /*  9 */ 'D9',  /* 10 */ 'N7',  /* 11 */ 'N8',
  /* 12 */ 'N9',  /* 13 */ 'D13', /* 14 */ 'SAB',
  /* 15 */ 'N10', /* 16 */ 'N11', /* 17 */ 'N12', /* 18 */ 'D18',
  /* 19 */ 'N13', /* 20 */ 'N14', /* 21 */ 'SAB',
  /* 22 */ 'N15', /* 23 */ 'D23', /* 24 */ 'N17', /* 25 */ 'N18',
  /* 26 */ 'N19', /* 27 */ 'D27', /* 28 */ 'SAB',
  /* 29 */ 'N20', /* 30 */ 'N23', /* 31 */ 'N24', /* 32 */ 'D32',
  /* 33 */ 'N25', /* 34 */ 'N26', /* 35 */ 'SAB',
  /* 36 */ 'N27', /* 37 */ 'D37', /* 38 */ 'N28', /* 39 */ 'N29', /* 40 */ 'N30',
];

// ── 표를 짓는다 ──────────────────────────────────────────────────
function buildNights() {
  if (DAY_PLAN.length !== CAMPAIGN_DAYS)
    throw new Error(`배치표가 ${DAY_PLAN.length}칸이다 — ${CAMPAIGN_DAYS}칸이어야 한다`);
  for (let d = 1; d <= CAMPAIGN_DAYS; d++) {
    const want = isSabbath(d), got = DAY_PLAN[d - 1] === 'SAB';
    if (want !== got) throw new Error(`${d}일: 안식일이어야 ${want} 인데 배치표는 ${got} 다`);
  }
  const out = {};
  // 1차 — 구 카드와 안식일부터 앉힌다(초안 칸은 비워 둔다)
  DAY_PLAN.forEach((id, i) => {
    const day = i + 1, key = 'N' + day;
    if (id === 'SAB') {
      out[key] = {
        name: `밤 ${day} — 안식일`,
        teaches: '안식일 — 전투 없음. 상인도 오지 않고 젖도 짜지 않는다. 아무것도 하지 않고 쉰다.',
        sabbath: true,
        spawn: {}, concurrent: 0, spawnMult: 1, howl: false,
        // 원장은 구 정적 밤과 같다 — 30밤시트 *"안정성 100% 확정 → 우유 만액"*.
        ledgerStab: 100, ledgerKills: 0, ledgerPieces: 0, gbPieces: 0, threatCut: 0,
      };
      return;
    }
    if (id.startsWith('D')) return;                 // 2차에서 이웃 보고 채운다
    const c = CARD[id];
    if (!c) throw new Error(`배치표가 없는 카드를 부른다 — ${id}`);
    // 이름 앞머리의 밤 번호만 **그 날짜로** 고친다. 뒷부분(부제)은 카드 그대로다.
    out[key] = { ...c, name: String(c.name).replace(/^밤\s*\d+/, `밤 ${day}`), cardId: id };
  });
  // 2차 — 초안 칸을 **양옆 전투 밤의 가운데값**으로 채운다
  const combatAt = (d) => (d >= 1 && d <= CAMPAIGN_DAYS && out['N' + d] && !out['N' + d].sabbath
                            ? out['N' + d] : null);
  DAY_PLAN.forEach((id, i) => {
    if (!id.startsWith('D')) return;
    const day = i + 1, key = 'N' + day, dr = DRAFT[id];
    if (!dr) throw new Error(`초안 카드가 없다 — ${id}`);
    let lo = null, hi = null;
    for (let d = day - 1; d >= 1 && !lo; d--) lo = combatAt(d);
    for (let d = day + 1; d <= CAMPAIGN_DAYS && !hi; d++) hi = combatAt(d);
    const a = lo ?? hi, b = hi ?? lo;
    if (!a) throw new Error(`${day}일 초안의 이웃을 못 찾았다`);
    const mid = (x, y) => Math.round((x + y) / 2);
    const kinds = new Set([...Object.keys(a.spawn), ...Object.keys(b.spawn)]);
    const spawn = {};
    for (const k of kinds) spawn[k] = mid(a.spawn[k] ?? 0, b.spawn[k] ?? 0);
    out[key] = {
      name: `밤 ${day} — ${dr.name}`,
      teaches: dr.teaches,
      draft: true,                       // ⚠ 내가 지은 카드다 — 검수 대기
      spawn,
      concurrent: mid(a.concurrent, b.concurrent),
      spawnMult: (a.spawnMult + b.spawnMult) / 2,
      howl: !!(a.howl && b.howl),
      flock: mid(a.flock, b.flock),
      ledgerStab: (a.ledgerStab + b.ledgerStab) / 2,
      ledgerKills: mid(a.ledgerKills, b.ledgerKills),
      ledgerPieces: mid(a.ledgerPieces, b.ledgerPieces),
      gbPieces: mid(a.gbPieces, b.gbPieces),
      threatCut: mid(a.threatCut, b.threatCut),
    };
  });
  // 안식일의 무리 수는 **직전 전투 밤**을 따른다(그 날 마당에 있는 양 그대로).
  for (let d = 1; d <= CAMPAIGN_DAYS; d++) {
    const n = out['N' + d];
    if (!n?.sabbath) continue;
    let prev = null;
    for (let p = d - 1; p >= 1 && !prev; p--) prev = combatAt(p);
    n.flock = prev?.flock ?? 20;
  }
  // ══════════════════════════════════════════════════════════════════
  //  **40일 난이도 목표 곡선** 【사장님 확정 2026-08-03 — 곡선 설계 위임】
  //    *"실 플레이 기준 밤1이 딱 적당해. 밤 2부터는 그보다 아주 살짝씩 어려워져야해."*
  //
  //  ■ 형태: **전투밤당 정확히 −1.0%p 의 직선.** 94(1일) → 60(40일).
  //    · 앵커 94 = 카드 N1 의 원장값 **그대로**다 — "밤1이 적당하다"는 앵커를
  //      옮기지 말라는 뜻이므로 값을 새로 짓지 않았다.
  //    · 걸음 1.0 은 고른 값이 아니라 **도출된 값**이다: 35전투밤 직선의 평균이
  //      94 − 17 = **77.0** 이고, 그것이 원장이 이미 가정한 「전투 밤 평균 77%」다.
  //      (구 계단 곡선의 실평균 76.2 → 77.0, 차이 +0.8. **경제곡선은 그대로다** —
  //       "경제곡선도 지금 괜찮은데 나머지는 건들지 말고"를 이 등식이 지킨다.)
  //    · 끝값 60 은 카드가 이미 박아 둔 마지막 구간 60.5 와 이어진다 — 보스 사흘의
  //      전제가 안 흔들린다.
  //  ■ 이것이 대체하는 것: 구 30장 값이 40일 위에 뭉개진 **계단+절벽**
  //    (5→6일 −6.7 · 29→30일 −9.2 절벽, 사이 5일짜리 평지 — "아주 살짝씩"의 정반대).
  //  ■ 카드가 말하던 값은 `ledgerStabCard` 로 남긴다 — 원장 재스냅샷(경제는 마지막) 때
  //    대조용이다. **실행 코드는 ledgerStab 을 안 읽는다**(world 디버그 표시 한 줄뿐) —
  //    이 값의 소비자는 적합 도구(headless_coef)와 산출기다.
  //  ■ 톱니(장 마지막 밤 피크 → 새 장 첫 밤 한 칸 하강)는 **안정성 목표에서 폐기된다.**
  //    사장님의 새 문장이 단조를 요구한다. 장의 성격 변화는 목표 곡선이 아니라
  //    적 구성·새 규칙 데뷔(카드)가 만든다 — 그쪽은 손대지 않았다.
  // ══════════════════════════════════════════════════════════════════
  let ci = 0;
  for (let d = 1; d <= CAMPAIGN_DAYS; d++) {
    const n = out['N' + d];
    if (!n || n.sabbath) continue;
    n.ledgerStabCard = n.ledgerStab;               // 카드(또는 초안 보간)가 말하던 값
    n.ledgerStab = STAB_TARGET_ANCHOR - STAB_TARGET_STEP * ci;
    ci++;
  }

  // ══════════════════════════════════════════════════════════════
  //  **40밤 리듬 헌장** 【2026-08-08 — 사장님 승인 「다 반영」】
  //    장마다 같은 마디(가르침→조합→시험→안식)를 여섯 번 반복하면 매너리즘이다.
  //    파형(밤 내부 곡선)·클라이맥스 로테이션·골짜기의 진화로 마디를 비튼다.
  //    파형의 뜻과 총량 보존은 world.js 의 WAVE_SHAPES 머리말이 정본이다.
  //
  //    · waves(파도형) — 조합 밤: 4·9·18·23·32 + 리프라이즈 36
  //    · hush-eased(정적-후-완만한 쇄도) — 29 빈 들(희박한 정찰량은 두고 release만 완화)
  //    · hush(정적-후-가파른 쇄도) — 37 숨죽인 밤(알고 맞는 더 깊은 재등장)
  //    · twin(이중봉) — 30 세 방향의 밤(arcs 3 과 한 몸)
  //    · 골짜기 다섯(10 쉼·19 안개·24 도강·29 정적·37 숨죽임)은 **다른 조용함**이다 —
  //      평온 → 불안 → 긴장 → 공포 → 각오. 같은 장치가 의미를 바꿔 돌아온다.
  //    · 클라이맥스 로테이션: 6 물량 · 13 무리전(pack) · 20 사자 예고전 · 27 폭풍 ·
  //      34 곰 예고전 — 안식일 전야가 매번 같은 종류이면 그것도 반복이다.
  // ══════════════════════════════════════════════════════════════
  const RHYTHM = {
    4:  { wave: 'waves' },                       // 파도형 데뷔 — 파도 사이 정적에 우물을 배운다
    9:  { wave: 'waves' },
    // 직전 12분 정본의 세 진행률을 ×5/6로 옮긴다. 마지막 620초 파도도 10분 안에 남는다.
    13: { pack: { at: [180, 420, 620].map((at) => at * NIGHT_DURATION_RATIO), n: 3 } },
    18: { wave: 'waves' },
    23: { wave: 'waves' },
    27: { stabStart: 85, howl: false },          // 폭풍 — 담이 무너지고(시작 85) 바람이 하울링을 지운다
    29: { wave: 'hush-eased' },
    30: { wave: 'twin', arcs: 3 },               // 세 방향 — 스폰이 세 부채꼴에서만 온다
    32: { wave: 'waves' },
    36: { wave: 'waves' },                       // 리프라이즈 — 파도마다 밀려오는 총정리
    37: { wave: 'hush' },
  };
  for (const [d, patch] of Object.entries(RHYTHM)) {
    if (out['N' + d] && !out['N' + d].sabbath) Object.assign(out['N' + d], patch);
  }
  return out;
}

export const NIGHTS = buildNights();

/** 전투 밤(안식일이 아닌 밤) 열쇠 — 날짜 순. */
const byNightNumber = (a, b) => Number(a.slice(1)) - Number(b.slice(1));
export const COMBAT_NIGHTS = Object.keys(NIGHTS)
  .filter((k) => !NIGHTS[k].sabbath)
  .sort(byNightNumber);
/** 안식일 열쇠 — 날짜 순. */
export const SABBATH_NIGHTS = Object.keys(NIGHTS)
  .filter((k) => NIGHTS[k].sabbath)
  .sort(byNightNumber);

/** 그 밤이 어느 구 카드에서 왔나. `null` 이면 안식일이거나 내가 지은 초안이다. */
export const cardIdOf = (nk) => NIGHTS[nk]?.cardId ?? null;
/** 구 카드 번호로 지금 날짜를 되찾는다 — 카드에 묶인 배선(보스·날씨)이 이걸 쓴다. */
export function nightKeyOfCard(cardId) {
  for (const k of Object.keys(NIGHTS)) if (NIGHTS[k].cardId === cardId) return k;
  return null;
}
// ⚠⚠ **날씨를 날짜로 적지 마라** 【40일 개편에서 실제로 어긋나 있었다】.
//   `audio.js` 가 *"비 = N15"* 라고 날짜를 박아 두었는데, 40일에서 N15 는
//   **협곡의 밤**이 됐다(비의 밤은 22일로 갔다). 그래서 **카드 문장에서 읽는다** —
//   30밤시트가 이미 `teaches` 첫머리에 날씨를 적어 두었다(「비 · 개활지 · …」).
//   지어내는 게 아니라 있는 정본을 읽는 것이다.
export const RAIN_NIGHTS = new Set(
  Object.keys(NIGHTS).filter((k) => /^비\s*·/.test(String(NIGHTS[k].teaches ?? ''))));
export const isRainNight = (nk) => RAIN_NIGHTS.has(nk);

// ══════════════════════════════════════════════════════════════════
//  ⚠⚠ **`NIGHT_ORDER` 는 「전건」이 아니다 — 앵커 열 밤이다**
//
//  이 목록이 10밤짜리인데 프로브·스윕이 전부 그것만 돌았다. 그래서 나머지 밤은
//  **한 번도 검사된 적이 없었고**, 밤 2 가 밤 1 의 4분의 1 인 채로 오래 살아 있었다
//  (2026-08-03 발견). 같은 10개짜리 사본이 `gb.html` 에도 손으로 박혀 있어서
//  **실험실에서 그 밤을 고를 수조차 없었다.**
//  → 이제 이름이 뜻을 말한다: **`SPAWN_ANCHORS`**. 「전부」가 필요하면
//    `Object.keys(NIGHTS)` 나 `COMBAT_NIGHTS` 를 써라. **목록을 손으로 적지 마라.**
//  ⚠ 구 이름(`NIGHT_ORDER`)은 화석 프로브 수십 개가 부르므로 **별명으로 남긴다.**
//    새 코드에서 쓰지 말 것.
// ══════════════════════════════════════════════════════════════════
export const SPAWN_ANCHORS = ['N1', 'N3', 'N8', 'N10', 'N12', 'N15', 'N20', 'N23', 'N30']
  .filter((k) => NIGHTS[k] && !NIGHTS[k].sabbath);
export const NIGHT_ORDER = SPAWN_ANCHORS;
export const NIGHT_NO = Object.fromEntries(
  Object.keys(NIGHTS).map((k) => [k, Number(k.slice(1))]));
// ①의 곡선 적합에서 제외하는 밤 — 안식일은 전투가 없으므로 잴 것이 없다.
export const FIT_EXCLUDE = new Set(SABBATH_NIGHTS);

// 그 밤의 무리 수 — **순수 파라미터.** 화면에 양은 없다. 안정성 배율에만 들어간다(3-5).
export const FLOCK_START = Object.fromEntries(
  Object.entries(NIGHTS).map(([k, v]) => [k, v.flock]));
// 3-8 상실 배분: 밤 손실 = LOSS_BASE × 배율. 밤별 하드코딩 대신 산출기 v2.0처럼 파생시킨다.
export const BASE_LOSS = Object.fromEntries(
  Object.entries(NIGHTS).map(([k]) => [k, LOSS_BASE]));

// ── 그 밤의 층별 스폰 예산 — **배수 적용의 정본은 이 함수 하나다.** ─────────
//   기본: 층마다 round(카드값 × 배수).
//   예외: `multExempt` 에 든 층은 배수를 받지 않고 **카드값 그대로** 통장에 든다
//   (N1 늑대층 raw 3칸). 이는 비율 추첨 통장이지 실제 출현 3마리 보장은 아니다.
//
//   ✅ **2026-07-28 — `world.js` 생성자가 이 함수를 부른다.** 그 전까지는 생성자가
//     `Object.entries(night.spawn).map(([k, v]) => [k, Math.round(v * sm)])` 로 직접 곱해서
//     회색박스 N1만 늑대 19를 스폰했다(원장·카드는 이미 3이었다). 실측 대조 — N1 예산
//     1855 → **1839**(정예 19 → 3), **나머지 9밤은 한 마리도 변하지 않았다.**
// ══════════════════════════════════════════════════════════════════
//  물량 손잡이 — **사장님 지시(2026-07-29) 「몹 수를 기존의 1.2배」.**
//
//  ■ ⚠ **30밤의 `spawnMult` 를 하나씩 안 고쳤다.** 그 값들은 10-C 실측 앵커(9밤)와
//    거기서 유도한 보간이라, 손으로 곱해 두면 **어느 것이 측정값이고 어느 것이
//    지시값인지 영영 못 가린다.** 손잡이를 하나 두고 곱한다 — 되돌리려면 1로 놓으면 된다.
//
//  ■ 이 값은 **예산과 동시 상한을 함께** 민다. 예산만 올리면 상한에 걸려 안 늘고,
//    상한만 올리면 예산이 말라 안 늘기 때문이다(둘 다 `sm` 에서 나온다).
//
//  ■ ⚠ **이 값은 임의로 고른 것이 아니라 목표에서 역산된다.**
//    지시는 둘이다 — 「앞 구간(0~639초) 총 몹 수 **×1.2**」와 「마지막 80초 **폭발**」.
//    그런데 `spawnScale` 이 곡선을 예산에 맞춰 정규화하므로 **두 구간은 서로를
//    밀어낸다** — 끝을 올리면 앞이 줄어든다. 둘을 동시에 만족시키는 예산은 하나뿐이다:
//        구 곡선에서 앞 구간의 몫 = 98.36%
//        신 곡선  S_앞 = 1.09554 · S_끝 = (1 − 640/720) × 24 = 2.6664
//        1.2 × 0.9836 × (S_앞 + S_끝) / S_앞 = 4.053  ← **이론값**
//    ⚠ **이론값은 안 맞았다 — 실측으로 잡았다.** 마지막 80초가 동시 상한에 붙어
//      포화되면서 끝이 제 몫을 다 못 쓰고, 그만큼 앞도 어긋난다(정규화가 포화를 모른다).
//      그래서 **앞 구간 스폰 수를 직접 재서** 보간했다: 4.053 → 3,959 / 4.6 → 4,436,
//      목표 4,367(구 3,639 × 1.2) → **4.52**.
//    **`world.js` 의 끝 rate(24.0)를 바꾸면 이 수도 같이 바꿔야 한다.**
//
//  ■ ⚠ 예산·경제 정합은 **나중에 한 번에** 잡는다(사장님 지시). 여기서 안 맞춘다.
export const SPAWN_VOLUME = 4.52;

// ══════════════════════════════════════════════════════════════════
//  ■■ 밤의 물량 배분 — **몫으로 적는다. rate 는 코드가 유도한다.**
//     【사장님 지시 2026-07-31】 *"초반2분 물량 5프로, 후반 2분 물량 55프로,
//                                나머지 40프로를 중간에 배치해."*
//
//  ■ **왜 rate 를 손으로 안 적나.** 구 구현은 rate 여섯(0.25/0.7/1.9/1.2/2.1/24.0)을
//    손으로 적어 두고 **그 몫이 얼마인지는 아무 데도 안 적혀 있었다.** 실제로 재 보니
//        첫 120초 **1.1%**  ·  마지막 80초 **70.9%**
//    였고, 그것이 *"1분 20초 넘어가면 3초에 한 번씩 레벨업"* 의 직접 원인이었다.
//    (타이머는 **남은 시간**을 세므로 「1분 20초」 = 경과 640초 = 구 폭발 시작점이다.)
//    **몫이 설계값인데 rate 로만 적으면 설계가 화면에 안 보인다.** 그래서 뒤집는다.
//
//  ■ **중간 8분의 내부 모양은 구 값 그대로다** — 3막 리듬은 헌법 1조라 안 건드린다.
//    바뀌는 것은 그 덩어리 전체가 밤에서 차지하는 **몫**뿐이다(정규화).
//
//  ■ **이 표는 총량이 아니라 배분만 정한다.** 캠페인은 tail·wave·boss를 포함한
//    실효 평균으로 `campaignSpawnTarget`에, 명시적 실험은 raw 평균으로 `totalBudget`에
//    각각 정규화한다. 어느 경로든 이 몫 표 자체를 바꿔 총 마리 수를 올리지는 않는다.
//    그래서 구 주석의 *"끝 rate 를 바꾸면 SPAWN_VOLUME 도 같이 바꿔야 한다"* 는
//    **이 개정에는 안 걸린다.** 그 문장은 「앞 ×1.2 + 끝 폭발」을 **동시에** 만족시키려던
//    구 명세의 것이고, 지금 명세는 총량이 아니라 **몫**을 직접 못 박기 때문이다.
//    ⚠ 다만 앞 구간의 **절대 마리 수는 늘어난다** — 몫이 29.1% → 45% 가 되므로 1.55배다.
//
//  ── ⚠⚠ 이 개정이 실제로 움직인 것 — **기록만 한다. 재수렴 안 한다** ────────
//    (사장님 지시: 경제·밸런스는 마지막에 한 번. 깨진 것은 기록만.)
//
//    ① **`gear_world_check` 3건이 붉어졌다.** 격리해서 원인을 확정했다 —
//       구 스폰 + 신 레벨곡선 = **전부 통과** / 신 스폰 + 구 레벨곡선 = **3건 실패**.
//       **레벨 곡선은 무죄이고 이 재배분이 원인이다.**
//         · `●●●○○ 안에서 시작 장비를 넘는다` — 랜덤 조합이 시작 장비 대비
//           +1.4% → **−18.3%**. 총 킬이 1,403 → 2,641 로 늘었는데 **시작 장비가 더 늘었다.**
//           시작 장비가 「성긴 고른 돌 = 무한 관통」이라 **밀집이 앞당겨질수록 유리**하다.
//           → *밀집도가 오르면 관통이 지배한다* 는 신호. 부품 밸런스 재수렴 때 볼 것.
//         · 납작한 돌 커버리지 `예산 5배에 거리 2.77배 → 5.69배` — 튐이 다음 적을
//           찾아 꺾이므로 **밀도가 높으면 계속 이어진다.** 로그 성장 계약이 깨졌다.
//    ② **동시 화면 개체(헌법 5조)** 실측(build=ramp·seed 7): 평균 N1 **72** · N8 **166** ·
//       N30 **242** — 밴드(1장 50~100 / 2~4장 100~250 / 5~6장 200~350) **안**이다.
//       ⚠ 다만 **최대**가 N8 792 · N30 624 로 튄다(마지막 2분에 55% 가 몰리므로).
//       밴드는 평균 기준이라 통과지만, 순간 밀도는 구 곡선보다 낮다(구는 80초에 71%).
//    ③ **경제는 안 움직였다** — 치즈 132/358/662 (구 곡선 154/402/966 · 평탄 140/386/705).
//
//  ■ **보스 밤은 폭발하지 않는다** — 그 규칙은 그대로다(N28·N29·N30).
//    카이팅·배후 급소 창이 **움직일 공간**을 전제하므로 끝을 폭발시키면 해법이 깨진다.
//    보스 밤의 끝은 **직전 구간 밀도의 1.2배**이며, 그 결과 몫이 55% 가 아니라 28.5% 다.
// ══════════════════════════════════════════════════════════════════
// ══════════════════════════════════════════════════════════════════
//  들판 — **벽이 없다**   【사장님 지시 2026-08-02】
//    *"벽 자체를 없애자."* → *"전체 맵 벽 제거하고 스폰통일 하고 … 전체 밤이야."*
//
//  ■ **왜 없앴나.** 벽이 있으면 모서리에 박히는 것이 최적이 된다 — 적이 90°에서만
//    오므로 안정성 반경 안의 수가 4분의 1로 준다. 「가만히 있기」가 이기는 게임이 된다.
//    막는 길은 셋이었다(가장자리 피해 · 몰이 적 · 벽 제거). **벽을 없애는 것이 근본**이고,
//    없는 모서리는 막을 필요가 없다. 뱀서류가 무한 맵을 쓰는 이유가 그것이다.
//
//  ■ **딸려오는 것 — 스폰 통일.** 벽이 없어지면 「필드 네 변」이라는 자리가 사라진다.
//    적은 **다윗 둘레**에서 나야 한다. 이 방식은 **이미 있었다** — N22(양 찾는 밤)가
//    쓰던 것이다(`spawnPoint` 의 rescue 갈래). 새로 만드는 게 아니라 전 밤으로 넓힌다.
//
//  ■ ⚠⚠ **계약은 「체감 밀도 동일」이다**(사장님). 총 개체 수가 아니라
//    **화면 안 적 수**가 지금과 같아야 한다 — 벽이 없어지면 화면 밖에도 적이 있으므로
//    총계는 더 이상 자가 아니다. 그래서 `densityCal` 을 **실측으로** 잡는다.
//
//  ■ 양은 이 변경과 무관하다 — **밤에 양은 원래 없다**(`world.flockN` 이 *"화면에 없다"*
//    고 적어 둔 그대로). 잃은 양 한 마리가 나오는 N22 만 예외다.
// ══════════════════════════════════════════════════════════════════
export const FIELD = {
  // 화면 — **스폰과 소멸의 자.** 논리 해상도이고 카메라가 이만큼 보여 준다.
  viewW: 1920, viewH: 1080,
  // 스폰 고리 — 화면 대각 반경 바깥. **N22 가 쓰던 값 그대로다**(새 상수가 아니다):
  //   `Math.hypot(1920,1080)/2 + UNIT` = 1101 + 32 = 1133
  spawnPad: UNIT,
  // 적을 치우는 반경 = 스폰 고리 × 이 배수. 스폰 자리에서 바로 지워지면 안 되므로
  //   1 보다 넉넉히 커야 하고, 너무 크면 화면 밖 적이 `concurrent` 를 먹어
  //   **화면이 도리어 빈다**(그 순간 「체감 밀도 동일」이 깨진다).
  cullMul: 1.55,
  // ══════════════════════════════════════════════════════════════
  //  **달아나면 앞에서 난다** — 뱀서 문법  【사장님 지시 2026-08-02】
  //    *"지금 실 플레이시 그냥 계속 도망가면 클리어 될거같은데 … 다른 뱀서 문법처럼"*
  //
  //  ■ 왜 도망이 이겼나(실측 N1·시드3·HP350):
  //        싸운다      화면 88마리 · 피해 530 · **4.9분에 죽음**
  //        도망(대각선) 화면 28마리 · 피해 340 · **완주**
  //    다윗 속도 **210**, 적은 **54~76**. 3~4배 빠르니 뒤는 영영 못 따라오고,
  //    앞은 고리 위에 **골고루** 나므로 진행 방향 원뿔에 드는 것은 1/4뿐이다.
  //    → 달리는 동안 늘 「빈 주머니」 안에 있게 된다. 화면이 3배 비었다.
  //
  //  ■ **속도를 안 건드린다.** 다윗을 느리게 하면 카이팅(이 게임의 유일한 조작)이
  //    통째로 망가지고, 적을 빠르게 하면 서서 싸우는 사람이 같이 죽는다.
  //    VS 가 하는 것은 그게 아니라 **「가는 쪽에 낳는 것」**이다.
  //  ■ **서 있으면 아무것도 안 바뀐다** — 치우침이 움직인 만큼만 걸리므로,
  //    제자리에서 싸울 때의 밀도(= 사장님이 「동일해야 한다」고 한 그 밀도)는 그대로다.
  runBias: 0.70,   // ⚠【잠정】 달리는 동안 **앞쪽 원뿔**에 나는 비율
  runCone: 75,     // ⚠【잠정】 그 원뿔의 반각(도). 좁으면 옆으로 새서 빠져나간다
  // ⚠ **앞에 낳는 것만으로는 부족했다**(실측: 화면 30 vs 서서 싸울 때 127).
  //   달리면 적이 **스쳐 지나가** 화면에 머무는 시간이 짧아진다 — 같은 밀도를 보려면
  //   그만큼 더 나야 한다. 사장님 지시: *"몹 출현을 더 높여야될 거 같은데?"*
  //   → 달리는 동안만 스폰이 `1 + runSpawnMul × runFrac` 배가 된다.
  //   **서 있으면 1배** 그대로다 — 「체감 밀도 동일」 계약은 그 자리에서 안 흔들린다.
  //  ── 훑기 (N1 · 2시드 · HP 350 · 화면 안 적 수) ──────────────────
  //     mul    카이팅   도망    비율    도망 결과
  //     0.0     108      30    ×0.28   8.6분에 죽음
  //  →  1.5     108      54    ×0.51   **3.6분에 죽음**  ← 채택
  //     3.0     127      83    ×0.65   1.5분   ← 카이팅까지 밀린다. 여기서 멈췄다
  //     4.5     147     116    ×0.79   1.1분
  //
  //  ── ⚠ 계약 확인은 **HP 무한(12분 완주)** 으로 해야 한다 ────────────
  //    HP 350 은 5분쯤 죽으므로 후반이 안 재진다. 무한으로 다시 재니 처음엔
  //    **화면 366 → 1038 (+184%)** 로 계약이 박살나 있었다 — 카이팅에서도 날것
  //    신호가 0.3 쯤 나와서 그게 후반 스폰율에 곱해져 눈덩이가 됐다.
  //    → `world.js` 의 **죽은 구간(GATE 0.60)** 으로 잡았다. 다시 재서:
  //         mul=0  화면 393  →  mul=1.5  화면 400   (+1.9%)   ✓ 계약 지켜짐
  //         도망 HP350:  mul=0  9.2분에 죽음  →  mul=1.5  **2.1분에 죽음**
  //    ⇒ 카이팅(사장님 실플레이)은 그대로고, 도망만 최악의 수가 된다.
  runSpawnMul: 1.5,
  // ══════════════════════════════════════════════════════════════
  //  **밀도 보정** — 사장님 계약 *"체감 밀도와 압박은 동일해야해"* 의 실행부
  //
  //  ■ 자는 **「화면 안 적 수」** 다. 총 개체가 아니다 — 벽이 없어지면 화면 밖에도
  //    적이 있으므로 총계는 더 이상 사람이 보는 수가 아니다.
  //  ■ ⚠ **「전」의 값을 한 번 잘못 짚었다.** 처음엔 플레이어 중심 사각형으로 쟀는데,
  //    벽이 있던 시절엔 **카메라가 고정이라 사람이 필드 전체를 봤다.** 그러니
  //    「전」의 화면 안 적 수는 그때의 **총개체**다(N1 396 · N8 2195 · N22 113).
  //    N22 만 예외로 그때도 카메라가 따라갔다 — 그래서 그 밤만 사각형 값이 맞다.
  //
  //  ── 실측 (2시드 · 12분 완주 · HP 무한) ────────────────────────
  //     cal      N1(396)        N8(2195)       N22(113)      평균 오차
  //     1.00   497 ×1.26     2216 ×1.01     180 ×1.59        29%
  //  →  0.92   365 ×0.92     2017 ×0.92     129 ×1.14        **10%**  ← 채택
  //     0.85   349 ×0.88     1781 ×0.81     123 ×1.09        13%
  //     0.78   274 ×0.69     1703 ×0.78     116 ×1.03        19%
  //
  //  ⚠ **한 상수로 세 밤을 다 맞출 수는 없다.** 차이가 구조적이기 때문이다 —
  //    N22 는 구 판에서 필드 가장자리가 스폰 고리를 **잘라 주고** 있었고(3배 필드에
  //    벽이 있었다), 그 가림막이 없어지자 360° 가 다 열려 +14% 가 남는다.
  //    셋을 ±14% 안에 넣는 값이 0.92 이고, 그보다 내리면 N1·N8 이 같이 무너진다.
  densityCal: 0.92,
};

// 앞·뒤 2분은 절대 길이를 보존하고, 줄어든 2분은 중간 8분에서만 뺀다.
// 중간 내부 분기들은 직전 120~600초 구간 안의 상대 위치를 새 120~480초 구간에
// 선형 사상한다. 따라서 216→192, 302→256.5, 504→408, 600→480이며 자유값이 없다.
const SPAWN_HEAD_SEC = 2 * 60;
const SPAWN_TAIL_SEC = 2 * 60;
const SPAWN_MID_END_SEC = NIGHT_SEC - SPAWN_TAIL_SEC;
const SPAWN_BASE_MID_END_SEC = NIGHT_BASE_SEC - SPAWN_TAIL_SEC;
const retimeSpawnMidSec = (oldSec) => SPAWN_HEAD_SEC
  + (oldSec - SPAWN_HEAD_SEC)
    * (SPAWN_MID_END_SEC - SPAWN_HEAD_SEC)
    / (SPAWN_BASE_MID_END_SEC - SPAWN_HEAD_SEC);
const retimeSpawnPhaseSec = (oldSec) => oldSec <= SPAWN_HEAD_SEC ? oldSec
  : oldSec <= SPAWN_BASE_MID_END_SEC ? retimeSpawnMidSec(oldSec)
    : SPAWN_MID_END_SEC + (oldSec - SPAWN_BASE_MID_END_SEC);

export const SPAWN_SHAPE = {
  headUntil: SPAWN_HEAD_SEC / NIGHT_SEC, // 초반 2분
  tailFrom:  SPAWN_MID_END_SEC / NIGHT_SEC, // 후반 2분 시작 = 8:00
  head: 0.05,                  // 그 2분이 밤 전체 물량에서 갖는 몫
  mid:  0.40,                  // 그 사이 6분
  tail: 0.55,                  // 마지막 2분
  // 중간 6분의 **내부 모양** — [구간 끝 p, 상대 rate]. 구 곡선의 상대 위치 보존.
  //   0.7 정찰 뒤 · 1.9 본대(하울링 30초 뒤) · 1.2 소강 · 2.1 마지막 파도
  midBands: [216, 302, 504, 600]
    .map((oldSec, i) => [retimeSpawnMidSec(oldSec) / NIGHT_SEC, [0.7, 1.9, 1.2, 2.1][i]]),
  // HUD 진단 상태 다섯 개도 없애지 않는다. 중간은 위와 같은 선형 사상, 마지막
  // `밤의 끝` 경계는 절대 2분인 꼬리 안의 기존 위치(0.88 × 720)를 그대로 옮긴다.
  phaseEnds: [120, 302, 504, 0.88 * NIGHT_BASE_SEC]
    .map((oldSec) => retimeSpawnPhaseSec(oldSec) / NIGHT_SEC),
  bossTailMul: 1.2,            // 보스 밤 끝 = 직전 구간 밀도의 이 배수
  // ══════════════════════════════════════════════════════════════
  //  마지막 2분을 **깎는다**   【사장님 지시 2026-08-02】
  //    *"후반 2분 남았을때부터 물량 미친거같거든? 이거를 지금 기준 0.8 배로 줄여.
  //      경제 생각하지 말고, 그냥 줄이라면 줄여."*
  //
  //  ⚠⚠ **`tail`(0.55)은 마지막 구간의 원래 몫이고, 이 값은 그 위에 얹는 상대 cut이다.**
  //    둘을 합치면 「언제 얼마나 몰리는가」와 「그 구간을 얼마나 누르는가」가 한 숫자에
  //    섞인다. 캠페인 실효 평균은 둘을 따로 읽어 총량을 맞추므로, tail은 리듬의 몫,
  //    tailCut은 마지막 2분의 상대 두께라는 역할이 그대로 남는다.
  //
  //  → 실제 파형에는 `world.spawnRate()` 가 마지막 2분에만 곱한다. 캠페인 기본 런은
  //    이 cut까지 `avgEffectiveSpawnRate`로 정규화하되, 밤1의 현행 실효 몫을 기준으로
  //    삼는다. 그래서 밤1의 실제 총량은 그대로이고, 다른 파형도 총량이 아니라 끝의
  //    상대 두께만 0.8배가 된다. 명시적 spawnMult 실험은 종전처럼 정규화 밖이다.
  //  ⚠ **보스 밤에도 걸린다.** 보스 밤은 이미 끝이 얇은데(`bossTailMul` 1.2) 거기서
  //    또 0.8 이 곱해진다. 지시가 밤을 안 갈랐으므로 그대로 두되, 여기 적어 둔다.
  tailCut: 0.80,
};

// 그 밤의 실효 배수 — **모두 이 함수 하나를 거친다.** 예산·상한·검산이 갈라지면
// 「화면에 보이는 수」와 「검사기가 세는 수」가 달라진다.
// ⚠ **보스 밤은 이 손잡이 밖이다** — 다만 그 판단은 **여기서 안 한다.**
//   보스 밤 목록의 정본은 `boss.js` 의 `BOSS[].nights` 이고, config 가 그것을 import 하면
//   **순환**이 된다(boss.js 가 config 의 UNIT 을 쓴다 — 실제로 터졌다).
//   그래서 **이미 보스를 아는 `world.js` 가** 세 번째 인자로 알려 준다.
//  ⚠ **보스 밤도 1.0 이 아니다 — 1.2349 다.** 「원래대로」가 그 뜻이기 때문이다.
//    보스 밤의 마지막 80초를 직전 구간의 1.2배(2.52)로 두껍게 하면, 정규화가 그 몫을
//    **앞 구간에서 빼 간다** — 실측에서 앞 구간이 구 대비 **0.41~0.59배**로 무너졌다.
//    앞을 구 값 그대로 두려면 그만큼만 예산을 채워 줘야 한다:
//        구 앞 몫 0.98356 · 신 앞 몫 0.79644 → 0.98356/0.79644 = **1.2349**
//    이 수는 「물량을 늘리는 값」이 아니라 **「끝을 두껍게 한 대가를 되돌리는 값」**이다.
//    끝 두께(2.52)를 바꾸면 이 수도 같이 바꿔야 한다.
export const BOSS_VOLUME = 1.2349;
export const spawnMultOf = (nk, base = NIGHTS[nk]?.spawnMult ?? 1, isBoss = false) =>
  base * (isBoss ? BOSS_VOLUME : SPAWN_VOLUME);

export function spawnBudgetOf(nk, sm = spawnMultOf(nk)) {
  const n = NIGHTS[nk], ex = new Set(n.multExempt ?? []);
  return Object.fromEntries(Object.entries(n.spawn)
    .map(([k, v]) => [k, ex.has(k) ? v : Math.round(v * sm)]));
}

// 10-A ① 확정값이 실제로 코드에 반영됐는지 검산하기 위한 파생값.
// World가 계산하는 것과 **같은 식**이어야 한다(종별 반올림 후 합산).
export function confirmedBudget(nk) {
  return Object.values(spawnBudgetOf(nk)).reduce((a, v) => a + v, 0);
}
export function confirmedCap(nk) {
  const n = NIGHTS[nk];
  return Math.max(1, Math.round(n.concurrent * spawnMultOf(nk)));
}

// 밤1은 원값이다. 이후 **다음 밤으로 넘어갈 때마다** 체력과 접촉 피해가 선형
// 0.25%만 오른다. 한 밤 안에서 오르는 플레이어 레벨은 적 능력치에 영향이 없다.
// 안식일에는 적이 없지만 밤 번호는 그대로 지나가므로 N2=+0.25%, N40=+9.75%다.
export const ENEMY_NIGHT_STEP = 0.0025;
export const ENEMY_NIGHT_MAX = 1 + (CAMPAIGN_DAYS - 1) * ENEMY_NIGHT_STEP;
export function enemyNightScale(nk = VOLUME_FLOOR_KEY) {
  const parsed = NIGHT_NO[nk] ?? Number(String(nk).replace(/^N/, ''));
  const safeNight = Math.max(1, Math.min(CAMPAIGN_DAYS, Math.floor(Number(parsed) || 1)));
  return Math.min(ENEMY_NIGHT_MAX,
    1 + (safeNight - 1) * ENEMY_NIGHT_STEP);
}

// ══════════════════════════════════════════════════════════════════
//  캠페인 물량 — 밤1을 고정점으로 두고 적 능력치와 같은 하루 걸음으로 오른다.
//
//  새 기울기를 만들지 않는다. 이미 캠페인 전건에 적용되는 `enemyNightScale()`의
//  +0.25%/일을 그대로 재사용해, 물량과 동시상한이 함께 아주 조금씩 커진다.
//  카드의 `spawn` 과 `spawnMult` 는 계속 종별 비율표이고, 안식일만 0이다.
//
//  파형·마지막 2분·보스 물량 감소는 총량을 깎는 손잡이가 아니라 밤 안의 리듬이다.
//  그 실효 평균 정규화는 파형을 실제로 아는 `world.js` 한 곳에서 맡는다.
// ══════════════════════════════════════════════════════════════════
export const VOLUME_FLOOR_KEY = 'N1';             // 구 이름은 프로브 호환 별명으로 유지
export const NIGHT_VOLUME_CURVE = Object.freeze({
  baseNight: 1,
  finalNight: 40,
  finalFactor: ENEMY_NIGHT_MAX,
  linearShare: 1,
});

// 구 바닥의 면제 목록을 읽는 외부 프로브를 깨지 않되, 새 곡선에서 빠지는 것은
// 실제 비전투 밤(안식일)뿐이다. 보스 밤은 raw 곡선을 받은 뒤 전투 중 −40%가 걸린다.
export const VOLUME_FLOOR_EXEMPT = new Set(SABBATH_NIGHTS);

export function nightVolumeFactor(nk) {
  const n = NIGHTS[nk];
  if (!n || n.sabbath) return 0;
  return enemyNightScale(nk);
}

/**
 * 밤1 raw 예산을 10분의 5/6로 옮긴 값을 고정점으로 삼고, 이후는 이미 검증된
 * `enemyNightScale()`과 같은 하루 걸음으로 올린다. 종별 비율은 각 밤 카드가 맡는다.
 */
export function campaignSpawnTarget(nk) {
  if (!NIGHTS[nk] || NIGHTS[nk].sabbath) return 0;
  return Math.round(confirmedBudget(VOLUME_FLOOR_KEY)
    * NIGHT_DURATION_RATIO * nightVolumeFactor(nk));
}

/** 밤1의 현재 동시상한을 보존한 그 밤의 캠페인 상한 목표. */
export function campaignConcurrentTarget(nk) {
  if (!NIGHTS[nk] || NIGHTS[nk].sabbath) return 0;
  return Math.max(1, Math.round(confirmedCap(VOLUME_FLOOR_KEY) * nightVolumeFactor(nk)));
}

/** 구 호출부용 호환 함수. 이제 바닥이 아니라 raw 캠페인 곡선으로 정규화한다. */
export function volumeFloorMul(nk) {
  const mine = confirmedBudget(nk);
  return mine > 0 ? campaignSpawnTarget(nk) / mine : 1;
}

/** 구 프로브 호환: 밤1 동시상한. 캠페인 런은 `campaignConcurrentTarget()` 을 쓴다. */
export function concurrentFloor(prayer = 1) {
  return Math.max(1, Math.round(confirmedCap(VOLUME_FLOOR_KEY) * prayer));
}

// ══════════════════════════════════════════════════════════════════
//  **마지막 밤의 끝 — 황금 화살표와 잃은 양**  【사장님 지시 2026-08-03】
//
//  *"12분지나고(보스처치 포함, 기존 12분게임) 나서 낮으로 이동하는게 아니라 빈
//    들판에서 황금색 화살표가 나오는거지. 거기로 이동하다 보면 (15초정도 방향은
//    5초간격으로 오른쪽으로 갔다가 아래로 갔다가 오른쪽으로 갔다가) 그동안
//    잃어버린 양들이 모여있는 방식"*
//
//  ■ 한 마리도 안 잃었으면 **딱 한 마리**가 있다.
//    *"나도 몰랐던 잃어버린 양 느낌."* — 아흔아홉을 두고 하나를 찾으러 가는 그 하나다.
//    그래서 `Math.max(1, 잃은 수)` 다. 0 마리인 화살표 끝은 없다.
//
//  ⚠ **10분 전투시간은 그대로다.** 이 구간은 밤 시계(`NIGHT_SEC`) **밖**에서 흐른다 —
//    안 그러면 마지막 밤만 전투가 9분 45초가 된다.
//  ⚠ 전투는 완전히 끝난다 — 적도 스폰도 없다. *"빈 들판"* 이 그 뜻이다.
// ══════════════════════════════════════════════════════════════════
export const FINALE = {
  sec: 15,                                      // 새 경로를 실제로 걸어야 하는 시간
  legSec: 5,                                    // 화면 진행 표시용 세 박자
  sampleSec: 0.1,                               // 되짚기 판정용 이동 표본 간격
  retraceRadius: 0.4 * UNIT,                    // 이 안의 과거 표본은 이미 걸은 길이다
  // 15초를 채운 순간 현재 위치 둘레에 양 무리를 만든다. 고정 월드 좌표는 없다.
  sheepNear: 4.5 * UNIT,
  sheepSpread: 5 * UNIT,
};
/** 여정의 **마지막 밤**인가. 그 밤만 10분 뒤에 화살표가 뜬다. */
export const isFinalNight = (nk) => nk === 'N' + CAMPAIGN_DAYS;
